import "../../resources/js/menu";
const Menu = () => {
  return (
    <>
      <nav id="siteMenu" className="site-menu">
        <div className="desktop-inner-container">
          <div className="top-part flex-container align-center justify-between">
            <div className="left-inner-part flex-container align-center">
              <button
                className="close-menu block"
                aria-label="Cerrar menú"
                title="Cerrar menú"
                ariaxpanded="false"
                datatarget="siteMenu"
              >
                <div className="close-bars">
                  <span className="block"></span>
                  <span className="block"></span>
                </div>
                <p className="hide-mobile">Cerrar</p>
              </button>
              <a href="/" className="menu-logo-link block" title="Crónica">
                <svg
                  width="105.171"
                  height="20.455"
                  className="block"
                  viewBox="0 0 105.171 20.455"
                >
                  <g transform="matrix(1, 0.017, -0.017, 1, 0.339, -0.79)">
                    <path
                      d="M2.3,0A2.214,2.214,0,0,1,4.663,2.053,2.05,2.05,0,0,1,4.426,3.09,3.884,3.884,0,0,1,3.367,4.325,3.7,3.7,0,0,1,1.6,4.9c-.334,0-.192-.026-.193-.108A2.53,2.53,0,0,0,1.4,4.357a.984.984,0,0,0-.34-.478C1.025,3.85.979,3.813.927,3.768a2.106,2.106,0,0,1-.375-.316L.527,3.438A2.02,2.02,0,0,1,0,2.13,2.227,2.227,0,0,1,2.3,0"
                      transform="translate(37.21 0.14)"
                      fill="#fb0d01"
                    />
                    <path
                      d="M2.453,0A1.967,1.967,0,0,1,4.494,1.52a2.332,2.332,0,0,1-1.82,2.587,2.485,2.485,0,0,1-.593.083A1.972,1.972,0,0,1,.037,2.669,2.327,2.327,0,0,1,1.857.083,2.529,2.529,0,0,1,2.453,0"
                      transform="translate(67.889 0)"
                      fill="#fb0d01"
                    />
                    <path
                      d="M104.732,7.86c.024,0,.492.015-.186,1s-2.4,3.368-3.979,4.234a7.1,7.1,0,0,1-3.217.93,3.9,3.9,0,0,1-.605-.033,2.718,2.718,0,0,1-1.857-1.215,3.275,3.275,0,0,1-.234-1.06c-.322-.077-.444-.039-.587.084-.341.3-2.187,1.845-3.913,1.874-1.932-.08-2.819-.8-3.234-1.478a10.369,10.369,0,0,1-.652-1.823c-.04-.055-.068-.148-.2-.145-.165,0-.492.148-1.2.68-1.226.913-4.243,3.316-7.245,3.366q-.221,0-.442-.011C74.4,14.076,73.389,12.745,73,12.194a9.642,9.642,0,0,1-.815-2.146.33.33,0,0,0-.307-.2.832.832,0,0,0-.523.288A35.749,35.749,0,0,1,65.8,13.862a5.568,5.568,0,0,1-1.732.345,1.684,1.684,0,0,1-1.835-1.068,3.09,3.09,0,0,1,.273-2.576c.178-.42.593-1.426.348-1.421-.653.434-4.006,4.7-7.167,5.235a11.118,11.118,0,0,1-1.637.172c-1.4.022-2.121-.41-2.48-1.38-.449-1.21.409-2.954.711-3.518s2.244-4.356,2.347-4.555c.012-.034.26-.655-.082-.649A1.182,1.182,0,0,0,54,4.7,36.246,36.246,0,0,0,49.465,9.3a41.607,41.607,0,0,0-3.078,5.008.782.782,0,0,1-.557.441c-.119.012-.607.023-1.2.033-1.195.019-2.747.033-2.829.033-.04,0-.141-.031.083-.536.259-.589,2.7-6.278,2.83-6.578.023-.057.447-1.161.144-1.156-.627.327-1.467,1.1-1.868,1.286a11.371,11.371,0,0,1-1.495.56c-.2.031-.836,1.132-1.144,1.622s-2.878,4.338-5.562,4.743a9.93,9.93,0,0,1-1.267.109,3.52,3.52,0,0,1-3-1.063,4.1,4.1,0,0,1-.747-1.966c-.026-.356-.016-1.03-.015-1.066-.006-.01-.113-.206-.27-.2-.358.24-4.254,3.681-6.037,4.317a8,8,0,0,1-2.423.556,1.879,1.879,0,0,1-2.031-1.4c-.608-1.94.682-4.127,1.5-5.279s1.92-2.817,1.976-2.9c.02-.026.377-.515-.008-.612a1.933,1.933,0,0,0-.466-.041,3.042,3.042,0,0,0-.409.033c-.044.05-.88,1-2.34,2.729s-6.024,6.705-10.25,7.513a14.828,14.828,0,0,1-2.513.275A6.62,6.62,0,0,1,.847,13.449c-1.458-1.8-.819-5.141.308-6.915C2.436,4.519,5.308,1.148,9.24.3A12.111,12.111,0,0,1,11.584,0c2.245-.037,3.261.807,3.693,1.426A3.811,3.811,0,0,1,14.4,6.138c-2.018,1.846-3.17,2.084-4.4,2.109A2.25,2.25,0,0,1,7.686,7.015,1.828,1.828,0,0,1,8.1,5.235a2.371,2.371,0,0,1,1.9-.895,3.185,3.185,0,0,1,.336.011,1.308,1.308,0,0,1,1.241.742c.105.243.073.431.13.534a1.366,1.366,0,0,0,.751-.188c.057-.041,1.126-.834,1.147-1.716A1.869,1.869,0,0,0,11.5,1.95a2.515,2.515,0,0,0-.642.093C9.7,2.382,6.429,3.528,5.1,6.684s.322,4.852,1.317,5.207a3.059,3.059,0,0,0,1.011.116A13.777,13.777,0,0,0,15.6,8.4c4.16-3.543,4.616-3.682,4.475-4.352a3.859,3.859,0,0,1,.089-2.337A2.181,2.181,0,0,1,21.888.6a1.329,1.329,0,0,1,.656.157,4.956,4.956,0,0,1,1.49,1.4c.12.106.2.155.288.154a1.078,1.078,0,0,0,.436-.191,3.093,3.093,0,0,1,1.288-.335,1.343,1.343,0,0,1,.878.254,2.443,2.443,0,0,1,.711,2.667,14.46,14.46,0,0,1-2.079,3.533,10.3,10.3,0,0,0-1.486,2.8c-.02.409.084,1.014.568,1.006A.838.838,0,0,0,24.906,12a23.876,23.876,0,0,0,4.568-3.684,14.21,14.21,0,0,0,2-2.456c.453-.785,2.675-3.244,4.867-3.549a10.188,10.188,0,0,1,1.235-.1,4.539,4.539,0,0,1,3.2.873,2.981,2.981,0,0,1,.8,1.847c.049.525-.066.731.115.848A.633.633,0,0,0,42,5.83a3.645,3.645,0,0,0,2.126-.991A13.544,13.544,0,0,0,46.081,3a13.417,13.417,0,0,0,.88-1.133l4.64-.076c.022,0,.448.025.411.332A20.917,20.917,0,0,1,50.944,4.55a1.28,1.28,0,0,0-.213.712.7.7,0,0,0,.735-.34c.284-.386,3.43-3.257,4.977-3.382.195-.016.394-.026.594-.03,1.387-.022,2.8.29,2.851,1.267.062,1.118-1,3.4-1.619,4.547a30.757,30.757,0,0,0-1.4,2.822c-.215.584-.365,1.172-.07,1.3A8.11,8.11,0,0,0,60.27,9.225a64.339,64.339,0,0,0,5.013-5.6c.808-1.207,1.536-2.11,1.919-2.166.127-.019.567-.032,1.1-.04,1.062-.018,2.416-.02,2.487-.02.036,0,.715.064.433.578s-3.292,6.4-3.451,6.709c-.025.048-.5.95-.432,1.251.052.212.158.5.525.492a1.52,1.52,0,0,0,.649-.2,24.216,24.216,0,0,0,3.812-2.985c.422-.488,2.135-3.373,3.9-4.494a7.831,7.831,0,0,1,4.191-1.465,7.328,7.328,0,0,1,1.263.1,3.916,3.916,0,0,1,3.3,3.23A3.671,3.671,0,0,1,81.94,8.382a5.984,5.984,0,0,1-.654.05c-1.565.025-2.218-.726-2.356-1.8a1.627,1.627,0,0,1,1.3-1.7,2.057,2.057,0,0,1,1.552.457.7.7,0,0,0,.529.291.931.931,0,0,0,.3-.07,1.127,1.127,0,0,0,.336-1.789,2.885,2.885,0,0,0-2.02-.654,3.6,3.6,0,0,0-1.459.331,6.278,6.278,0,0,0-3.292,3.534c-.449,1.584-.477,4.382,1.746,4.573.248.021.494.028.735.024a9.046,9.046,0,0,0,4.867-1.667A26.119,26.119,0,0,0,86.076,7.99a10.3,10.3,0,0,1,4.4-5.968A9.216,9.216,0,0,1,94.93.778a5.9,5.9,0,0,1,1.343.109,3.163,3.163,0,0,1,1.472,1.064,1.451,1.451,0,0,0,.852.534c.434-.111.35-.762.359-.992.013-.3.084-.389.831-.4.085,0,.178,0,.282,0,.278,0,.982-.005,1.669-.016.824-.014,1.582-.03,1.622-.031s.6.007.058.915c-.572.951-3.591,7.117-3.879,7.685a3.048,3.048,0,0,0-.568,1.663.553.553,0,0,0,.555.465.881.881,0,0,0,.412-.125,9.117,9.117,0,0,0,2.237-2.121c.427-.562.807-1.51.986-1.592a5.85,5.85,0,0,1,1.068-.074c.279,0,.491,0,.5,0M95.4,8.622c1.542-1.746,2.031-4.037,1.085-5.1a1.678,1.678,0,0,0-1.341-.55,4.687,4.687,0,0,0-3.165,1.775C90.425,6.5,89.936,8.78,90.885,9.853a1.683,1.683,0,0,0,1.339.546A4.709,4.709,0,0,0,95.4,8.622M39.163,8.7c.067-.236-.258-.517-.513-.721A1.77,1.77,0,0,1,38.2,6.543a4.739,4.739,0,0,1,.791-2.009c.141-.219-.037-.29-.313-.285a3.3,3.3,0,0,0-.823.145,5.779,5.779,0,0,0-2.349,1.684c-1.643,1.78-2.29,4.033-1.447,5.031a1.419,1.419,0,0,0,1.156.472,5.19,5.19,0,0,0,3.34-1.894l.039-.04a2.349,2.349,0,0,0,.235-.329,2.577,2.577,0,0,0,.334-.62"
                      transform="translate(0 3.661)"
                      fill="#fb0d01"
                    />
                  </g>
                </svg>
              </a>
            </div>
            {/*
                    <div className="flex-container align-center">
                        <a href="#" className="apoya-btn header-btn" title="Apoyá a Crónica">
                            <div className="heart-holder">
                                <svg viewBox="0 0 13.3 12.2">
                                    <path d="M9.7,0C9.7,0,9.7,0,9.7,0C8.5,0,7.4,0.5,6.7,1.4C5.9,0.5,4.8,0,3.7,0C1.7,0,0,1.6,0,3.6c0,0,0,0,0,0.1c0,2.5,2.3,4.6,5.7,7.7l1,0.9l1-0.9c3.4-3.1,5.7-5.2,5.7-7.7C13.4,1.7,11.7,0,9.7,0z" fill="transparent" />
                                    <path d="M9.7,0c-1.2,0-2.2,0.5-3,1.4C5.9,0.5,4.8,0,3.7,0C1.7,0,0,1.6,0,3.6c0,0,0,0,0,0.1c0,2.5,2.3,4.6,5.7,7.7l1,0.9l1-0.9c3.4-3.1,5.7-5.2,5.7-7.7C13.4,1.7,11.7,0,9.7,0C9.7,0,9.7,0,9.7,0z M6.7,10.4L6.7,10.4H6.6C3.4,7.5,1.3,5.6,1.3,3.7c0-1.3,1-2.3,2.2-2.3c0,0,0.1,0,0.1,0c1,0,2,0.6,2.4,1.6h1.2c0.4-1,1.3-1.6,2.4-1.6c1.3,0,2.3,1,2.3,2.2c0,0,0,0.1,0,0.1C12,5.6,9.9,7.5,6.7,10.4z" fill="#FB0D01"/>
                                </svg>
                            </div>
                            <span>Apoyá a Crónica</span>
                        </a>
                        <a href="#" className="ingresa-btn header-btn" title="Ingresá">Ingresá</a>
                    </div>
                    */}
          </div>
          <div className="main-desktop-columns-holder">
            <nav className="menu-links-holder first-menu-links-holder desktop-first-column">
              <ul>
                <a
                  href="/seccion/policiales/"
                  className="menu-link block"
                  title="Policiales"
                >
                  Policiales
                </a>
                <a
                  href="/seccion/politica/"
                  className="menu-link block"
                  title="Política"
                >
                  Política
                </a>
                <a
                  href="/seccion/mundo/"
                  className="menu-link block"
                  title="Mundo"
                >
                  Mundo
                </a>
                <a
                  href="/seccion/paranormal/"
                  className="menu-link block"
                  title="Paranormal"
                >
                  Paranormal
                </a>
                <a
                  href="/seccion/salud/"
                  className="menu-link block"
                  title="Salud"
                >
                  Salud
                </a>
                <a
                  href="/seccion/tecnologia/"
                  className="menu-link block"
                  title="Tecnología"
                >
                  Tecnología
                </a>
                <a
                  href="/seccion/opinion/"
                  className="menu-link block"
                  title="Opinión"
                >
                  Opinión
                </a>
                <a
                  href="/seccion/sociedad/"
                  className="menu-link block"
                  title="Sociedad"
                >
                  Sociedad
                </a>
                <a
                  href="/seccion/cineyseries/"
                  className="menu-link block"
                  title="Cine y Series"
                >
                  Cine y Series
                </a>
                <a
                  href="/seccion/numeros-y-destino/"
                  className="menu-link block"
                  title="Números y Destino"
                >
                  Números y Destino
                </a>
                <a
                  href="/seccion/cocina/"
                  className="menu-link block"
                  title="Cocina"
                >
                  Cocina
                </a>
                <a
                  href="/seccion/cosa-de-locos/"
                  className="menu-link block"
                  title="Cosa De Locos"
                >
                  Cosa De Locos
                </a>
              </ul>
            </nav>
            <div className="en-vivo-container desktop-third-column">
              <a
                href="https://www.cronica.com.ar/cronica-en-vivo"
                className="en-vivo-link flex-container align-center justify-center"
                title="En vivo Crónica HD"
              >
                <div className="outer-circle flex-container align-center justify-center">
                  <span className="inner-circle block"></span>
                </div>
                <span className="text uppercase">En vivo Crónica HD</span>
              </a>
              <nav className="menu-links-holder">
                <ul>
                  <a
                    href="/seccion/cronicahd/"
                    className="menu-link block"
                    title="Videos"
                  >
                    Videos
                  </a>
                  <a
                    href="/seccion/horoscopo/"
                    className="menu-link block"
                    title="Horóscopo"
                  >
                    Horóscopo
                  </a>
                  <a
                    href="/seccion/clima/"
                    className="menu-link block"
                    title="Clima"
                  >
                    Clima
                  </a>
                  <a
                    href="/transito/"
                    className="menu-link block"
                    title="Tránsito"
                  >
                    Tránsito
                  </a>
                  <a
                    href="/seccion/santoral/"
                    className="menu-link block"
                    title="Santoral"
                  >
                    Santoral
                  </a>
                  <a
                    href="/seccion/efemerides/"
                    className="menu-link block"
                    title="Efemérides"
                  >
                    Efemérides
                  </a>
                  <a
                    href="/seccion/numeros-y-destino/"
                    className="menu-link block"
                    title="Loterías y Quinielas"
                  >
                    Loterías y Quinielas
                  </a>
                </ul>
              </nav>
              <div className="club-cronica flex-container flex-column align-center justify-center">
                <svg className="bg-svg" viewBox="0 0 209 150">
                  <g>
                    <path
                      className="st1"
                      d="M120,21.1l31.2-3.3L147.4,0h-35.6l1.7,15.8C113.8,19.1,116.7,21.5,120,21.1z"
                      fill="#F0F0F0"
                    />
                    <path
                      className="st2"
                      d="M151.2,17.9l10.3,48.4c0.7,3.2,3.9,5.3,7.1,4.6l40.4-8.6V11.8L151.2,17.9z"
                      fill="#FFE6E5"
                    />
                    <path
                      className="st3"
                      d="M204,0h-56.6l3.8,17.9l57.8-6.1V5C209,2.2,206.8,0,204,0z"
                      fill="#F1D9D7"
                    />
                    <path
                      className="st4"
                      d="M59.9,35.3L56.2,0H5C2.2,0,0,2.2,0,5v42.7l54.5-5.8C57.8,41.6,60.2,38.6,59.9,35.3z"
                      fill="#EDEDED"
                    />
                  </g>
                </svg>
                <svg
                  className="logo-svg"
                  width="72.038"
                  height="64.02"
                  viewBox="0 0 72.038 64.02"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      x1="0.683"
                      y1="0.458"
                      x2="0.884"
                      y2="0.954"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stopColor="#e20b00" />
                      <stop offset="1" stopColor="#a30800" />
                    </linearGradient>
                  </defs>
                  <g transform="translate(-1.069 -4.03)">
                    <g transform="translate(7.492 4.03)">
                      <g>
                        <path
                          d="M4,0H54.972a4,4,0,0,1,4,4V37.8a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z"
                          fill="url(#linear-gradient)"
                        />
                        <g
                          transform="translate(10.21 5.094)"
                          style={{ isolation: "isolate" }}
                        >
                          <rect
                            width="38.554"
                            height="9.535"
                            transform="translate(0 22.828)"
                          />
                          <g transform="translate(1.539 24.321)">
                            <path
                              d="M2090.7,1887.866a.811.811,0,0,0-1.578,0,.553.553,0,0,0,.173.39v0l.008,0a.648.648,0,0,0,.127.1c.016.014.031.025.044.034a.3.3,0,0,1,.114.144.71.71,0,0,1,0,.13c0,.026-.048.034.065.034a1.38,1.38,0,0,0,.6-.164,1.2,1.2,0,0,0,.364-.364.561.561,0,0,0,.085-.309"
                              transform="translate(-2076.467 -1887.242)"
                              fill="#fff"
                            />
                            <path
                              d="M2104.467,1887.851a.794.794,0,1,1-.886-.443.708.708,0,0,1,.886.443"
                              transform="translate(-2079.905 -1887.278)"
                              fill="#fff"
                            />
                            <path
                              d="M2107.74,1891.485a4.44,4.44,0,0,0-.531.014c-.061.024-.194.305-.341.471a2.982,2.982,0,0,1-.767.622c-.19.091-.306-.007-.326-.106-.031-.153.1-.324.2-.493s1.151-2,1.349-2.277-.016-.273-.016-.273-.908,0-1.113,0c-.343-.007-.372.016-.379.114,0,.069.022.263-.1.291-.087.021-.225-.071-.312-.16a1.069,1.069,0,0,0-.494-.325,3.315,3.315,0,0,0-1.966.311,3.192,3.192,0,0,0-1.518,1.761,9.631,9.631,0,0,1-.873.576,3.251,3.251,0,0,1-1.905.462c-.75-.068-.729-.9-.569-1.374a2,2,0,0,1,1.132-1.04,1.256,1.256,0,0,1,1.176.114.318.318,0,0,1-.122.533.235.235,0,0,1-.281-.07.723.723,0,0,0-.524-.144c-.121.019-.49.163-.447.5.047.364.319.607,1.009.539a1.137,1.137,0,0,0,1.047-1.112c-.02-.471-.562-.9-1.1-.98a2.71,2.71,0,0,0-1.853.382,6.025,6.025,0,0,0-1.339,1.324,8.217,8.217,0,0,1-1.305.872c-.311.137-.372,0-.4-.091s.152-.372.152-.372,1.1-1.836,1.2-1.987-.144-.175-.144-.175-1.086-.015-1.215,0-.38.282-.66.638a20.292,20.292,0,0,1-1.724,1.647,2.7,2.7,0,0,1-1.183.645c-.1-.038-.046-.212.029-.386a8.857,8.857,0,0,1,.486-.836,3.448,3.448,0,0,0,.568-1.351c-.013-.333-.636-.417-1.16-.386a4.487,4.487,0,0,0-1.7.986c-.1.114-.235.152-.25.1a.358.358,0,0,1,.075-.211,5.845,5.845,0,0,0,.373-.722c.014-.091-.136-.1-.136-.1h-1.573a4.2,4.2,0,0,1-.3.333,4.427,4.427,0,0,1-.668.541c-.439.313-.769.3-.829.268s-.021-.1-.036-.253a.831.831,0,0,0-.263-.556,2.082,2.082,0,0,0-1.5-.253,2.926,2.926,0,0,0-1.664,1.036,4.441,4.441,0,0,1-.688.723,8.02,8.02,0,0,1-1.563,1.078c-.243.075-.289-.146-.279-.287a2.966,2.966,0,0,1,.516-.83,4.27,4.27,0,0,0,.721-1.045.68.68,0,0,0-.229-.8.863.863,0,0,0-.734.015c-.138.066-.159.076-.245.008a1.564,1.564,0,0,0-.5-.426.688.688,0,0,0-.809.272,1.021,1.021,0,0,0-.041.7c.045.2-.111.24-1.535,1.278a4.382,4.382,0,0,1-3.126,1c-.334-.11-.884-.626-.42-1.562a2.967,2.967,0,0,1,1.969-1.357c.4-.094.942.078.924.515-.011.263-.4.507-.4.507s-.107.059-.145.075a.1.1,0,0,1-.11-.023c-.02-.031-.007-.087-.042-.16-.045-.094-.142-.2-.417-.228a.9.9,0,0,0-.762.254.5.5,0,0,0-.149.529c.033.143.3.381.775.38a2.183,2.183,0,0,0,1.5-.608,1.045,1.045,0,0,0,.318-1.4c-.186-.242-.7-.6-2.038-.367a4.7,4.7,0,0,0-2.766,1.823,1.794,1.794,0,0,0-.137,2.064,2.845,2.845,0,0,0,2.748.646,7.747,7.747,0,0,0,3.505-2.194c.5-.508.8-.8.8-.8a1.039,1.039,0,0,1,.3.007c.13.031,0,.183,0,.183s-.4.515-.682.857a1.825,1.825,0,0,0-.532,1.57c.2.584.9.456,1.5.273a10.784,10.784,0,0,0,2.018-1.244c.076-.053.136.046.136.046s-.007.213,0,.319a1.14,1.14,0,0,0,.244.59c.167.183.531.411,1.441.306s1.8-1.247,1.906-1.389.325-.471.394-.479a3.991,3.991,0,0,0,.509-.16c.137-.052.424-.28.6-.363s-.015.334-.015.334l-.989,1.95c-.091.174-.031.16-.031.16s1.245.008,1.366,0a.268.268,0,0,0,.19-.129,12.706,12.706,0,0,1,1.065-1.481,11.693,11.693,0,0,1,1.556-1.35c.373-.221.212.12.212.12s-.708,1.184-.815,1.349-.4.683-.257,1.047c.155.388.533.5,1.388.381a5.815,5.815,0,0,0,2.4-1.509c.174-.1,0,.262-.076.4a.828.828,0,0,0-.1.768c.149.438.826.349,1.2.234a12.488,12.488,0,0,0,1.9-1.086c.214-.175.28-.023.28-.023a2.838,2.838,0,0,0,.266.646,1.754,1.754,0,0,0,1.4.637,4.745,4.745,0,0,0,2.617-.965c.441-.281.448-.189.478-.151a2.925,2.925,0,0,0,.212.546,1.239,1.239,0,0,0,1.034.456,2.539,2.539,0,0,0,1.388-.538c.121-.091.2-.023.2-.023a.9.9,0,0,0,.074.318.936.936,0,0,0,.623.372,2.455,2.455,0,0,0,1.3-.25,4.946,4.946,0,0,0,1.366-1.245c.234-.289.067-.3.067-.3m-22.2-.071a.727.727,0,0,1-.115.184.843.843,0,0,1-.081.1l-.014.013c-.562.524-1.248.7-1.528.4s-.05-.971.514-1.495a1.979,1.979,0,0,1,.8-.492c.176-.044.477-.075.384.048a1.337,1.337,0,0,0-.277.6.489.489,0,0,0,.147.431c.085.062.194.148.169.217m19.035.253c-.531.515-1.218.67-1.531.346s-.141-1.006.391-1.522,1.219-.67,1.532-.344.14,1-.392,1.52"
                              transform="translate(-2072.276 -1887.6)"
                              fill="#fff"
                            />
                          </g>
                          <g transform="translate(3.336 0)">
                            <path
                              d="M2076.109,1859.95c.016.288.025.568.025.838v.763q0,1.042-.051,1.816c-.035.517-.076.957-.128,1.321s-.1.665-.152.9a4.064,4.064,0,0,1-.153.558,2.027,2.027,0,0,1-.812,1.181,2.765,2.765,0,0,1-1.423.318,3,3,0,0,1-1.6-.343,2.164,2.164,0,0,1-.812-1.232,8.019,8.019,0,0,1-.229-.966,13.985,13.985,0,0,1-.165-1.5q-.064-.94-.089-2.388t-.026-3.684q0-2.388.038-3.849t.115-2.311a12.7,12.7,0,0,1,.164-1.283q.089-.431.192-.787a2.182,2.182,0,0,1,.8-1.207,2.812,2.812,0,0,1,1.536-.343,3.154,3.154,0,0,1,1.474.318,2.146,2.146,0,0,1,.914,1.435,9.952,9.952,0,0,1,.281,1.562,22.308,22.308,0,0,1,.1,2.35v1.08c0,.229-.01.436-.025.622h-1.322q.026-.279.026-.622v-1.055q0-1.193-.076-2.007a9.188,9.188,0,0,0-.2-1.321,1.248,1.248,0,0,0-.419-.787,1.287,1.287,0,0,0-.75-.2,1.148,1.148,0,0,0-.761.216,1.4,1.4,0,0,0-.381.775,6.108,6.108,0,0,0-.166.787q-.063.432-.1,1.219c-.024.525-.043,1.216-.051,2.071s-.013,1.969-.013,3.34.008,2.5.025,3.392.038,1.613.064,2.172.059,1,.1,1.309.088.58.14.8a1.361,1.361,0,0,0,.393.774,1.3,1.3,0,0,0,.826.215,1.015,1.015,0,0,0,.673-.2,1.345,1.345,0,0,0,.369-.711,14.84,14.84,0,0,0,.354-3.709v-.838c0-.237-.009-.5-.025-.787Z"
                              transform="translate(-2070.495 -1847.756)"
                              fill="#fff"
                            />
                            <path
                              d="M2085.18,1867.511v-19.23h1.371v17.782h3.074v1.448Z"
                              transform="translate(-2075.958 -1847.951)"
                              fill="#fff"
                            />
                            <path
                              d="M2101.459,1848.281h1.372v14.226q0,.965-.013,1.613t-.064,1.092a6.214,6.214,0,0,1-.127.762,2.9,2.9,0,0,1-.228.622,1.844,1.844,0,0,1-.9.966,3.576,3.576,0,0,1-1.512.279,3.728,3.728,0,0,1-1.511-.266,1.776,1.776,0,0,1-.9-.979,3.431,3.431,0,0,1-.241-.622,4.958,4.958,0,0,1-.14-.762q-.051-.445-.063-1.092t-.013-1.613v-14.226h1.422v14.226q0,.838.013,1.384t.051.889q.039.343.089.571a1.909,1.909,0,0,0,.152.433.859.859,0,0,0,.458.482,1.834,1.834,0,0,0,.711.127,1.745,1.745,0,0,0,.7-.127.864.864,0,0,0,.444-.482,1.912,1.912,0,0,0,.153-.433c.033-.152.063-.343.089-.571s.042-.524.05-.889.013-.826.013-1.384Z"
                              transform="translate(-2080.4 -1847.951)"
                              fill="#fff"
                            />
                            <path
                              d="M2111.922,1867.511v-19.23h3.15a2.738,2.738,0,0,1,1.282.242,1.764,1.764,0,0,1,.725.978q.1.3.191.635a5.5,5.5,0,0,1,.14.788c.033.3.059.661.076,1.067s.025.9.025,1.473q0,.891-.025,1.487t-.076,1a3.5,3.5,0,0,1-.128.635,2.236,2.236,0,0,1-.177.406,1.17,1.17,0,0,1-.533.508v.127a1.415,1.415,0,0,1,.584.457,1.378,1.378,0,0,1,.241.42,3.533,3.533,0,0,1,.153.7,11.961,11.961,0,0,1,.089,1.207q.025.749.025,1.918,0,.889-.025,1.5c-.017.406-.043.754-.077,1.042a4.983,4.983,0,0,1-.139.749q-.09.318-.216.648a1.9,1.9,0,0,1-.736,1,2.528,2.528,0,0,1-1.219.241Zm2.82-10.466a2.113,2.113,0,0,0,.813-.1.745.745,0,0,0,.331-.381,3.206,3.206,0,0,0,.127-.356,2.825,2.825,0,0,0,.076-.521q.026-.343.038-.888t.012-1.461q0-.838-.012-1.372t-.051-.876a4.209,4.209,0,0,0-.089-.546,2.648,2.648,0,0,0-.126-.381.82.82,0,0,0-.331-.419,1.143,1.143,0,0,0-.56-.115h-1.676v7.418Zm.3,9.12a1.291,1.291,0,0,0,.6-.115.8.8,0,0,0,.343-.444,2.283,2.283,0,0,0,.127-.406,5.862,5.862,0,0,0,.089-.6q.038-.368.05-.94t.012-1.46q0-.966-.012-1.562c-.008-.4-.021-.716-.038-.953a3.557,3.557,0,0,0-.077-.559,3.673,3.673,0,0,0-.126-.406.8.8,0,0,0-.343-.394,2.084,2.084,0,0,0-.852-.114h-1.524v7.951Z"
                              transform="translate(-2085.909 -1847.951)"
                              fill="#fff"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g transform="translate(1.069 55.465)">
                      <path
                        d="M2143.086,1883.166V1871h3.762v1.447H2144.5v3.827h2.313v1.383H2144.5v4h2.331v1.511Z"
                        transform="translate(-2143.086 -1870.788)"
                      />
                      <path
                        d="M2146.193,1883.166V1871h1.415v10.659h2.17v1.511Z"
                        transform="translate(-2141.467 -1870.788)"
                      />
                      <path
                        d="M2155.008,1878.576a4.454,4.454,0,0,1,.032.546v.546a11.681,11.681,0,0,1-.1,1.655,3.731,3.731,0,0,1-.355,1.182,1.663,1.663,0,0,1-.667.707,2.161,2.161,0,0,1-1.062.233,2.953,2.953,0,0,1-1.285-.218,1.4,1.4,0,0,1-.659-.779,3.438,3.438,0,0,1-.194-.61,7.139,7.139,0,0,1-.128-.949c-.033-.4-.056-.9-.073-1.511s-.024-1.387-.024-2.33q0-1.622.042-2.58c.025-.638.061-1.134.1-1.487a3.908,3.908,0,0,1,.144-.756c.055-.149.1-.278.145-.386a1.516,1.516,0,0,1,.619-.755,2.61,2.61,0,0,1,1.245-.225,3.428,3.428,0,0,1,.95.106,1.429,1.429,0,0,1,.61.36,2.31,2.31,0,0,1,.5,1.125,9.489,9.489,0,0,1,.177,1.993c0,.214,0,.4-.009.563s-.012.333-.023.514h-1.35c.01-.171.017-.321.017-.45v-.594a10.344,10.344,0,0,0-.056-1.188,2.237,2.237,0,0,0-.17-.676.509.509,0,0,0-.241-.273,1.017,1.017,0,0,0-.4-.064.764.764,0,0,0-.465.113.734.734,0,0,0-.224.4c-.032.129-.063.271-.088.426a5.865,5.865,0,0,0-.064.683c-.017.3-.028.7-.034,1.2s-.007,1.145-.007,1.937,0,1.463.007,1.978.017.927.034,1.238a6.933,6.933,0,0,0,.064.723c.025.172.056.321.088.45a.752.752,0,0,0,.232.394.864.864,0,0,0,.522.12.564.564,0,0,0,.442-.168,1.12,1.12,0,0,0,.233-.49,4.975,4.975,0,0,0,.12-.748c.027-.283.041-.613.041-.988v-.5c0-.149-.006-.306-.016-.466Z"
                        transform="translate(-2139.226 -1870.86)"
                      />
                      <path
                        d="M2154.116,1883.166V1871h1.415v10.659h2.171v1.511Z"
                        transform="translate(-2137.337 -1870.788)"
                      />
                      <path
                        d="M2160.067,1871h1.414v8.793c0,.407,0,.75-.008,1.028s-.015.52-.032.724a2.462,2.462,0,0,1-.264.979,1.346,1.346,0,0,1-.683.669,3.532,3.532,0,0,1-1.295.184,3.574,3.574,0,0,1-1.31-.184,1.335,1.335,0,0,1-.683-.669,2.385,2.385,0,0,1-.176-.45,2.914,2.914,0,0,1-.1-.53c-.022-.2-.035-.446-.039-.724s-.007-.621-.007-1.028V1871h1.462v8.793c0,.321,0,.581.007.779s.014.362.025.491a1.291,1.291,0,0,0,.055.3,1.4,1.4,0,0,0,.106.225.479.479,0,0,0,.249.218,1.256,1.256,0,0,0,.426.056,1.176,1.176,0,0,0,.416-.056.492.492,0,0,0,.242-.218,1.3,1.3,0,0,0,.1-.225,1.184,1.184,0,0,0,.056-.3c.011-.13.021-.292.025-.491s.008-.458.008-.779Z"
                        transform="translate(-2135.895 -1870.788)"
                      />
                      <path
                        d="M2160.551,1883.166V1871h2.523a2.656,2.656,0,0,1,.931.146,1.21,1.21,0,0,1,.611.506,2.759,2.759,0,0,1,.329,1.005,10.337,10.337,0,0,1,.105,1.623q0,.723-.04,1.18a3.687,3.687,0,0,1-.121.724,1.1,1.1,0,0,1-.209.409,1.084,1.084,0,0,1-.306.242v.1a2.647,2.647,0,0,1,.4.289.891.891,0,0,1,.242.435,4.173,4.173,0,0,1,.112.811c.021.348.032.823.032,1.422a10.218,10.218,0,0,1-.106,1.616,2.7,2.7,0,0,1-.337,1.005,1.252,1.252,0,0,1-.6.514,2.448,2.448,0,0,1-.884.144Zm2.282-6.8a.973.973,0,0,0,.4-.072.475.475,0,0,0,.242-.282,2.294,2.294,0,0,0,.113-.587c.021-.251.032-.582.032-.987,0-.3,0-.542-.009-.724s-.012-.332-.022-.45a2.6,2.6,0,0,0-.041-.289,1.771,1.771,0,0,0-.056-.209.545.545,0,0,0-.24-.313.79.79,0,0,0-.386-.09h-.9v4Zm.144,5.418a.791.791,0,0,0,.354-.072.529.529,0,0,0,.233-.3,2.283,2.283,0,0,0,.12-.627q.033-.4.032-1.06,0-.755-.04-1.19a2.329,2.329,0,0,0-.137-.659.512.512,0,0,0-.25-.291,1.025,1.025,0,0,0-.394-.064h-.931v4.26Z"
                        transform="translate(-2133.984 -1870.788)"
                      />
                      <path
                        d="M2165.7,1883.166V1871h2.363a2.842,2.842,0,0,1,1.237.21,1.453,1.453,0,0,1,.659.754,4.635,4.635,0,0,1,.193.587,5.558,5.558,0,0,1,.127.86c.034.365.053.837.066,1.414s.015,1.33.015,2.25q0,1.43-.024,2.315t-.072,1.422a6.433,6.433,0,0,1-.12.844,3.372,3.372,0,0,1-.185.561,1.354,1.354,0,0,1-.644.749,3.018,3.018,0,0,1-1.253.2Zm2.331-1.5a.852.852,0,0,0,.475-.1.66.66,0,0,0,.233-.377c.031-.118.06-.251.088-.4a5.062,5.062,0,0,0,.056-.658c.011-.289.018-.676.024-1.158s.008-1.12.008-1.913c0-.771,0-1.4-.008-1.872s-.014-.863-.024-1.158-.027-.52-.047-.676a2.136,2.136,0,0,0-.1-.409.8.8,0,0,0-.25-.387.772.772,0,0,0-.458-.113h-.916v9.227Z"
                        transform="translate(-2131.301 -1870.788)"
                      />
                      <path
                        d="M2169.362,1883.166V1871h3.763v1.447h-2.348v3.827h2.316v1.383h-2.316v4h2.331v1.511Z"
                        transform="translate(-2129.391 -1870.788)"
                      />
                      <path
                        d="M2175.322,1883.166v-10.722h-1.512V1871h4.437v1.447h-1.5v10.722Z"
                        transform="translate(-2127.072 -1870.788)"
                      />
                      <path
                        d="M2177.345,1882.45a4.429,4.429,0,0,1-.193-.6,6.294,6.294,0,0,1-.127-.893c-.033-.374-.056-.864-.073-1.469s-.025-1.387-.025-2.341.01-1.73.025-2.33.039-1.087.073-1.461a6.027,6.027,0,0,1,.127-.884,5.383,5.383,0,0,1,.193-.612,1.425,1.425,0,0,1,.644-.779,3.628,3.628,0,0,1,2.475,0,1.428,1.428,0,0,1,.642.779,4.892,4.892,0,0,1,.192.612,5.757,5.757,0,0,1,.13.884c.031.374.057.862.072,1.461s.024,1.378.024,2.33-.008,1.734-.024,2.341-.04,1.095-.072,1.469a6.009,6.009,0,0,1-.13.893,4.085,4.085,0,0,1-.192.6,1.421,1.421,0,0,1-.642.779,3.628,3.628,0,0,1-2.475,0A1.418,1.418,0,0,1,2177.345,1882.45Zm2.573-1.028c.032-.129.057-.268.078-.418s.042-.373.056-.666.031-.694.042-1.2.015-1.179.015-2.027,0-1.524-.008-2.032-.016-.911-.031-1.206-.035-.514-.057-.659-.048-.281-.081-.409a.771.771,0,0,0-.233-.411.763.763,0,0,0-.475-.12.722.722,0,0,0-.465.12.8.8,0,0,0-.226.394c-.031.129-.062.268-.087.418a5.634,5.634,0,0,0-.064.666q-.025.443-.033,1.206t-.008,2.032c0,.848,0,1.521.008,2.027s.017.9.033,1.2a5.708,5.708,0,0,0,.064.666c.025.15.056.289.087.418a.752.752,0,0,0,.226.4.764.764,0,0,0,.465.112.776.776,0,0,0,.468-.112A.763.763,0,0,0,2179.918,1881.421Z"
                        transform="translate(-2125.447 -1870.86)"
                      />
                      <path
                        d="M2180.551,1883.166V1871h2.364a2.838,2.838,0,0,1,1.237.21,1.44,1.44,0,0,1,.659.754,4.413,4.413,0,0,1,.193.587,5.673,5.673,0,0,1,.129.86q.047.548.063,1.414t.018,2.25c0,.954-.01,1.727-.025,2.315s-.041,1.063-.073,1.422a6.1,6.1,0,0,1-.121.844,3.181,3.181,0,0,1-.185.561,1.348,1.348,0,0,1-.642.749,3.023,3.023,0,0,1-1.254.2Zm2.333-1.5a.845.845,0,0,0,.472-.1.656.656,0,0,0,.233-.377c.033-.118.062-.251.089-.4a5.6,5.6,0,0,0,.057-.658c.009-.289.017-.676.022-1.158s.009-1.12.009-1.913c0-.771,0-1.4-.009-1.872s-.014-.863-.022-1.158-.028-.52-.049-.676a1.981,1.981,0,0,0-.1-.409.8.8,0,0,0-.248-.387.772.772,0,0,0-.457-.113h-.917v9.227Z"
                        transform="translate(-2123.558 -1870.788)"
                      />
                      <path
                        d="M2184.541,1882.45a4.3,4.3,0,0,1-.191-.6,5.986,5.986,0,0,1-.129-.893c-.032-.374-.057-.864-.072-1.469s-.026-1.387-.026-2.341.009-1.73.026-2.33.04-1.087.072-1.461a5.737,5.737,0,0,1,.129-.884,5.192,5.192,0,0,1,.191-.612,1.433,1.433,0,0,1,.644-.779,3.626,3.626,0,0,1,2.475,0,1.433,1.433,0,0,1,.643.779,5.016,5.016,0,0,1,.192.612,5.638,5.638,0,0,1,.13.884c.031.374.056.862.071,1.461s.025,1.378.025,2.33-.008,1.734-.025,2.341-.04,1.095-.071,1.469a5.882,5.882,0,0,1-.13.893,4.175,4.175,0,0,1-.192.6,1.426,1.426,0,0,1-.643.779,3.626,3.626,0,0,1-2.475,0A1.426,1.426,0,0,1,2184.541,1882.45Zm2.573-1.028c.032-.129.057-.268.081-.418s.038-.373.056-.666.029-.694.039-1.2.017-1.179.017-2.027,0-1.524-.01-2.032-.015-.911-.032-1.206-.034-.514-.056-.659a3.8,3.8,0,0,0-.081-.409.612.612,0,0,0-.707-.531.727.727,0,0,0-.466.12.8.8,0,0,0-.225.394c-.032.129-.061.268-.087.418a5.362,5.362,0,0,0-.064.666q-.026.443-.032,1.206t-.009,2.032c0,.848,0,1.521.009,2.027s.015.9.032,1.2a5.429,5.429,0,0,0,.064.666c.026.15.056.289.087.418a.75.75,0,0,0,.225.4,1.026,1.026,0,0,0,.933,0A.753.753,0,0,0,2187.114,1881.421Z"
                        transform="translate(-2121.698 -1870.86)"
                      />
                      <path
                        d="M2188.938,1879.17a2.751,2.751,0,0,0-.04.4c-.006.151-.007.338-.007.563,0,.472.01.811.032,1.021a1.391,1.391,0,0,0,.144.521.612.612,0,0,0,.225.25.868.868,0,0,0,.4.071,1.067,1.067,0,0,0,.458-.071.673.673,0,0,0,.25-.281,1.637,1.637,0,0,0,.144-.58c.021-.234.032-.621.032-1.156v-.514a3.042,3.042,0,0,0-.017-.347c-.011-.09-.021-.171-.032-.241s-.026-.148-.047-.233a.819.819,0,0,0-.169-.338,2.63,2.63,0,0,0-.345-.289c-.129-.1-.274-.2-.436-.3s-.321-.206-.481-.314-.317-.217-.466-.33a3.5,3.5,0,0,1-.386-.328,1.612,1.612,0,0,1-.272-.363,1.674,1.674,0,0,1-.177-.521,6.114,6.114,0,0,1-.1-.82c-.022-.331-.032-.756-.032-1.27a7.105,7.105,0,0,1,.12-1.518,1.848,1.848,0,0,1,.411-.827,1.421,1.421,0,0,1,.6-.387,3.2,3.2,0,0,1,.962-.113,3,3,0,0,1,1.118.161,1.4,1.4,0,0,1,.586.434,1.771,1.771,0,0,1,.306.747,7.593,7.593,0,0,1,.081,1.263c0,.342-.008.624-.024.843a3.537,3.537,0,0,1-.072.538H2190.5a2.562,2.562,0,0,0,.041-.393c0-.155.007-.358.007-.6a6.335,6.335,0,0,0-.048-.909,1.1,1.1,0,0,0-.177-.473.432.432,0,0,0-.225-.169,1.335,1.335,0,0,0-.387-.042,1.1,1.1,0,0,0-.377.048.477.477,0,0,0-.216.193,1.157,1.157,0,0,0-.155.465,7.608,7.608,0,0,0-.039.933v.6c0,.156,0,.284.007.386a1.531,1.531,0,0,0,.031.257c.018.07.036.141.057.217a1.294,1.294,0,0,0,.161.314,2.031,2.031,0,0,0,.338.3,5.279,5.279,0,0,0,.7.45,7,7,0,0,1,.781.5,3.818,3.818,0,0,1,.426.347,1.541,1.541,0,0,1,.265.392c.042.1.08.193.113.291a1.889,1.889,0,0,1,.073.385c.015.161.026.368.032.619s.008.577.008.972c0,.419-.01.775-.032,1.07a7.328,7.328,0,0,1-.088.754,3.153,3.153,0,0,1-.138.531,3.862,3.862,0,0,1-.176.411,1.254,1.254,0,0,1-.611.561,2.907,2.907,0,0,1-1.19.193,2.994,2.994,0,0,1-1.036-.145,1.144,1.144,0,0,1-.6-.563,3.7,3.7,0,0,1-.178-.369,2.279,2.279,0,0,1-.129-.451,5.559,5.559,0,0,1-.072-.61q-.023-.354-.022-.869c0-.278.007-.521.022-.73s.035-.389.056-.54Z"
                        transform="translate(-2119.874 -1870.86)"
                      />
                    </g>
                  </g>
                </svg>
                <p className="club-cronica-link block">Unite al Club</p>
                <a
                  href="https://www.cronica.com.ar/clubcronica/"
                  className="cover-link"
                  title="Unite a Club Crónica"
                  rel="nofollow noreferrer"
                  target="_blank"
                ></a>
              </div>
            </div>
            <div className="inner-form-redes-sites-holder desktop-second-column">
              {/*
                        <div className="apoya-cronica-holder">
                            <div className="top-part flex-container align-center justify-between">
                                <img src="/arte/cronicaReact/apoya-cr-svg.svg" width="158" height="33" alt="Apoyá Crónica" title="Apoyá Crónica" loading="lazy"/>
                                <a href="#" className="apoya-btn header-btn" title="Apoyá a Crónica">
                                    <div className="heart-holder">
                                        <svg viewBox="0 0 13.3 12.2">
                                            <path d="M9.7,0C9.7,0,9.7,0,9.7,0C8.5,0,7.4,0.5,6.7,1.4C5.9,0.5,4.8,0,3.7,0C1.7,0,0,1.6,0,3.6c0,0,0,0,0,0.1c0,2.5,2.3,4.6,5.7,7.7l1,0.9l1-0.9c3.4-3.1,5.7-5.2,5.7-7.7C13.4,1.7,11.7,0,9.7,0z" fill="transparent" />
                                            <path d="M9.7,0c-1.2,0-2.2,0.5-3,1.4C5.9,0.5,4.8,0,3.7,0C1.7,0,0,1.6,0,3.6c0,0,0,0,0,0.1c0,2.5,2.3,4.6,5.7,7.7l1,0.9l1-0.9c3.4-3.1,5.7-5.2,5.7-7.7C13.4,1.7,11.7,0,9.7,0C9.7,0,9.7,0,9.7,0z M6.7,10.4L6.7,10.4H6.6C3.4,7.5,1.3,5.6,1.3,3.7c0-1.3,1-2.3,2.2-2.3c0,0,0.1,0,0.1,0c1,0,2,0.6,2.4,1.6h1.2c0.4-1,1.3-1.6,2.4-1.6c1.3,0,2.3,1,2.3,2.2c0,0,0,0.1,0,0.1C12,5.6,9.9,7.5,6.7,10.4z" fill="#FB0D01"/>
                                        </svg>
                                    </div>
                                    <span>Apoyá a Crónica</span>
                                </a>
                            </div>
                            <p>Necesitamos al Pueblo firme junto a Crónica para seguir ejerciendo un periodismo responsable, original y sin condicionamientos. Colaborá con Crónica. Si hoy no podés, no importa. Lo nuestro es incondicional.</p>
                        </div>
                        */}
              <div className="form-holder">
                <form
                  className="flex-container align-center"
                  action="https://www.cronica.com.ar/buscar.html"
                  method="post"
                >
                  <button type="submit">
                    <svg
                      className="lupa-icon block"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                    >
                      <use xlinkHref="#lupa-svg"></use>
                    </svg>
                  </button>
                  <input type="text" name="q" placeholder="Buscar en Crónica" />
                </form>
              </div>
              <div className="sites-grid-holder">
                <div className="depo-menu inner-site-item">
                  <svg width="105.687" height="32" viewBox="0 0 105.687 32">
                    <g transform="translate(0 5.507)">
                      <path
                        d="M207.713,380.911h5.352l3.3-6.334h-8.654V371.19h13.563v-5.914H201.157v9.3h-2.516c-1.391-5.023-5.848-9.3-13.144-9.3h-10.95v25.53H185.5c6.7,0,11.978-4.093,13.3-9.894h2.364v9.894h19.909v-5.913H207.713ZM185.5,385.36h-5.279V370.723H185.5c5.162,0,7.947,3.771,7.947,7.317C193.444,382.794,189.35,385.36,185.5,385.36Z"
                        transform="translate(-174.547 -364.794)"
                        fill="#333"
                      />
                      <path
                        d="M405.2,362.983a13.573,13.573,0,0,0-11.645,6.285c-1.262-3.533-4.6-5.8-8.955-5.8H372.387v11.858h-5.012l-3.3,6.334h8.314v7.338h6.556v-7.338H384.6a9.593,9.593,0,0,0,7.22-2.919,13.588,13.588,0,1,0,13.38-15.755Zm-20.933,12.339h-5.319V369.8h5.319c2.085,0,3.281,1.007,3.281,2.762S386.348,375.322,384.262,375.322Zm20.933,7.82a6.914,6.914,0,1,1,6.838-6.914A6.969,6.969,0,0,1,405.2,383.142Z"
                        transform="translate(-324.263 -362.983)"
                        fill="#333"
                      />
                    </g>
                    <path
                      d="M598.905,341l-9.864,3.589a18.407,18.407,0,0,1,2.083.971Z"
                      transform="translate(-501.977 -340.111)"
                      fill="#333"
                    />
                    <path
                      d="M607.242,353.587,614.459,348l-9.121,3.95A14.485,14.485,0,0,1,607.242,353.587Z"
                      transform="translate(-514.851 -345.64)"
                      fill="#333"
                    />
                    <path
                      d="M574.221,340.922l8.03-4.157-10.455,3.5A14.735,14.735,0,0,1,574.221,340.922Z"
                      transform="translate(-488.354 -336.766)"
                      fill="#333"
                    />
                    <path
                      d="M627.97,360.5l-9.248,3.978a14.577,14.577,0,0,1,1.488,2.22Z"
                      transform="translate(-525.423 -355.515)"
                      fill="#333"
                    />
                    <path
                      d="M636.99,373.75l-9.112,4.295a14.376,14.376,0,0,1,.887,2.527Z"
                      transform="translate(-532.657 -365.981)"
                      fill="#333"
                    />
                    <path
                      d="M633.254,394.948l9.143-7.478L633.01,392.3a14.624,14.624,0,0,1,.244,2.643Z"
                      transform="translate(-536.71 -376.82)"
                      fill="#333"
                    />
                    <path
                      d="M641.91,403.74l-8.615,4.924a14.838,14.838,0,0,1-.2,1.667"
                      transform="translate(-536.781 -389.672)"
                      fill="#333"
                    />
                    <path
                      d="M636.838,414.712l-8.46,5.256a14.432,14.432,0,0,1-1,2.784Z"
                      transform="translate(-532.263 -398.34)"
                      fill="#333"
                    />
                  </svg>
                  <a
                    href="https://www.depo.com.ar/"
                    className="cover-link"
                    title="DEPO"
                    rel="me nofollow noreferrer"
                    target="_blank"
                  ></a>
                </div>
                <div className="diario-show-menu inner-site-item">
                  <svg
                    width="85.621"
                    height="40.792"
                    viewBox="0 0 85.621 40.792"
                  >
                    <g transform="translate(-591.19 -290.604)">
                      <g transform="translate(597.422 290.604)">
                        <path
                          d="M108.052,45h.752a1.265,1.265,0,0,0,.911-.752l2.376-10.334c.079-.277-.2-.752-.515-.752h-.831l.792-3.366h7.919c5.7,0,8.909,2.732,8.909,7.523,0,6.1-3.92,10.928-12.077,10.928H107.3Zm8.671-.158c3.366,0,5.464-3.049,5.464-7.761,0-2.415-1.148-3.682-3.128-3.682h-.673l-2.613,11.443Z"
                          transform="translate(-107.3 -28.85)"
                          fill="#fff"
                        />
                        <path
                          d="M160.977,43.436l1.465-6.454c.079-.238-.119-.673-.4-.673h-.832l.673-2.93a11.491,11.491,0,0,1,4.039-.673c2.019,0,3.049,1.227,2.574,3.207l-1.623,6.969c-.04.277.2.673.436.673h.832l-.634,2.772a8.181,8.181,0,0,1-3.6.713C161.452,47.039,160.422,45.891,160.977,43.436Zm2.97-13.462a2.628,2.628,0,0,1,2.89-2.574,2.246,2.246,0,0,1,2.494,2.217,2.622,2.622,0,0,1-2.851,2.613A2.287,2.287,0,0,1,163.946,29.974Z"
                          transform="translate(-139.635 -27.4)"
                          fill="#fff"
                        />
                        <path
                          d="M180.6,51.409c0-3.405,2.692-4.751,5.939-4.751a8.041,8.041,0,0,1,2.653.317l.238-.99c.2-.911-.2-1.5-1.623-1.5a3.682,3.682,0,0,0-2.692,1.029H182.54l.911-4.039a17.556,17.556,0,0,1,5.86-.871c4.593,0,6.652,1.663,5.86,5.147l-1.188,5.108c-.04.277.2.673.436.673h.554l-.594,2.732a6.971,6.971,0,0,1-3.207.752c-1.782,0-2.653-.752-2.97-1.821a5.42,5.42,0,0,1-3.959,1.782A3.409,3.409,0,0,1,180.6,51.409Zm7.6-.079.475-2.1a2.734,2.734,0,0,0-.99-.158,1.578,1.578,0,0,0-1.623,1.7c0,.634.356.95,1.029.95A1.992,1.992,0,0,0,188.2,51.33Z"
                          transform="translate(-151.577 -35.373)"
                          fill="#fff"
                        />
                        <path
                          d="M218.577,54.144l2.1-9.067c.04-.238-.119-.673-.4-.673h-.832l.673-2.93a11.075,11.075,0,0,1,4-.673,2.39,2.39,0,0,1,2.574,2.494,4.375,4.375,0,0,1,3.92-2.415,3.014,3.014,0,0,1,.832.119l-1.069,4.633H229.7a6.335,6.335,0,0,0-3.524.99l-1.94,8.315h-5.108A.653.653,0,0,1,218.577,54.144Z"
                          transform="translate(-174.507 -35.494)"
                          fill="#fff"
                        />
                        <path
                          d="M248.977,43.436l1.465-6.454c.079-.238-.119-.673-.4-.673h-.832l.673-2.93a11.491,11.491,0,0,1,4.039-.673c2.019,0,3.049,1.227,2.574,3.207l-1.623,6.969c-.04.277.2.673.435.673h.832l-.633,2.772a8.181,8.181,0,0,1-3.6.713C249.452,47.039,248.422,45.891,248.977,43.436Zm2.97-13.462a2.628,2.628,0,0,1,2.89-2.574,2.225,2.225,0,0,1,2.494,2.217,2.622,2.622,0,0,1-2.851,2.613A2.287,2.287,0,0,1,251.946,29.974Z"
                          transform="translate(-192.791 -27.4)"
                          fill="#fff"
                        />
                        <path
                          d="M269.4,48.875a8.066,8.066,0,0,1,8.236-8.275c4.435,0,6.969,2.376,6.969,6.137a8,8,0,0,1-8.236,8.275C271.974,55.013,269.4,52.677,269.4,48.875Zm9.582-2.692c0-1.227-.515-1.861-1.386-1.861-1.584,0-2.534,2.97-2.534,5.345,0,1.267.475,1.9,1.386,1.9C278.032,51.568,278.982,48.638,278.982,46.183Z"
                          transform="translate(-205.216 -35.373)"
                          fill="#fff"
                        />
                      </g>
                      <g transform="translate(591.189 312.39)">
                        <path
                          d="M319.478,47.829H315.4l1.307-5.781h3.96l.119,2.3a4.26,4.26,0,0,0,1.623.2c1.465,0,2.455-.594,2.455-1.782,0-1.069-.792-1.386-2.376-2.059-2.178-.911-4.2-1.94-4.2-4.989,0-4.078,2.89-6.612,7.642-6.612a19.982,19.982,0,0,1,3.524.277H332.9l-1.267,5.345h-3.841l-.119-2.059a3.891,3.891,0,0,0-1.425-.2c-1.465,0-2.376.634-2.376,1.782,0,.95.634,1.307,1.663,1.742,3.445,1.346,5.147,2.494,5.147,5.5,0,3.841-2.494,6.612-7.6,6.612A20.717,20.717,0,0,1,319.478,47.829Z"
                          transform="translate(-315.4 -29.1)"
                          fill="#fff"
                        />
                        <path
                          d="M364.083,44.825l1.188-5.068c.2-.832-.04-1.267-1.148-1.267a5.259,5.259,0,0,0-1.188.2l-2.178,9.463h-5.108a.576.576,0,0,1-.475-.752l3.128-13.66c.04-.277-.158-.673-.4-.673h-.752l.752-3.366h6.177c.515,0,.792.436.634,1.148l-1.307,5.623a7.784,7.784,0,0,1,5.187-2.494c2.178,0,3.366,1.386,2.811,3.762l-1.5,6.494c-.04.277.158.673.435.673h.673l-.633,2.772a7.625,7.625,0,0,1-3.484.713C364.479,48.429,363.489,47.28,364.083,44.825Z"
                          transform="translate(-339.415 -29.462)"
                          fill="#fff"
                        />
                        <path
                          d="M397.8,48.875a8.066,8.066,0,0,1,8.236-8.275c4.435,0,6.969,2.376,6.969,6.137a8,8,0,0,1-8.236,8.275C400.374,55.013,397.8,52.677,397.8,48.875Zm9.582-2.692c0-1.227-.515-1.861-1.386-1.861-1.584,0-2.534,2.97-2.534,5.345,0,1.267.475,1.9,1.386,1.9C406.432,51.568,407.382,48.638,407.382,46.183Z"
                          transform="translate(-365.173 -36.047)"
                          fill="#fff"
                        />
                        <path
                          d="M437.948,45c-.04-.238-.277-.554-.475-.554H436.8l.673-2.93a7.12,7.12,0,0,1,3.207-.713c1.782,0,2.692.634,2.732,2.613l.2,5.187h.079l3.049-7.6h4.2l.634,7.879h.079A23.869,23.869,0,0,0,454.064,41h4.791l-.713,3.128a32.459,32.459,0,0,1-6.335,10.809H447.53l-.436-7.048h-.04l-3.286,7.048h-5.147Z"
                          transform="translate(-388.731 -36.167)"
                          fill="#fff"
                        />
                      </g>
                      <path
                        d="M309.467,50.693c-.572-.286-.667-.191-.667.477V63.658c0,.763.286.572.763.381,2.288-1.335,4.576-2.574,6.769-3.813,1.525-.858,3.146-1.716,4.767-2.669C317.189,55.173,313.471,52.981,309.467,50.693Z"
                        transform="translate(354.409 261.85)"
                        fill="#fff"
                      />
                    </g>
                  </svg>
                  <a
                    href="https://www.diarioshow.com/"
                    className="cover-link"
                    title="DiarioShow"
                    rel="me nofollow noreferrer"
                    target="_blank"
                  ></a>
                </div>
                <div className="bae-menu inner-site-item">
                  <svg
                    width="72.472"
                    height="38.712"
                    viewBox="0 0 72.472 38.712"
                  >
                    <g>
                      <path
                        d="M78.533,553.842c5.565,0,8.288,1.7,8.288,5.96,0,3.355-2.171,5.131-5.92,5.842v.237c3.592.434,6.986,1.7,6.986,6.236a6.584,6.584,0,0,1-2.328,5.408c-1.618,1.3-4.223,2.091-8.723,2.091H65.35v-1.381c2.8-.158,3.039-.316,3.039-2.25V557.434c0-1.973-.237-2.131-3.039-2.249v-1.342H78.533m-4.5,11.288h1.934c3.671,0,5.289-1.855,5.289-4.854,0-3.04-1.736-4.816-5.052-4.816-1.776.04-2.171.158-2.171,1.5Zm0,10.341c0,1.934.592,2.527,2.724,2.527,2.644,0,5.131-1.421,5.131-5.605,0-3.552-1.776-5.644-5.841-5.644H74.033Z"
                        transform="translate(-65.009 -553.685)"
                        fill="#fff"
                      />
                      <path
                        d="M154.391,579.258v-1.381l2.052-.2c.868-.079,1.026-.552.71-1.421-.631-2.013-1.658-4.973-2.131-6.355h-7.657c-.711,2.29-1.421,4.421-1.934,6.394-.236.869-.158,1.3.711,1.382l2.171.2v1.381h-8.407v-1.381c2.092-.12,2.447-.434,3.118-2.093,2.131-5.328,5.486-15.432,7.815-22.458h4.381c2.092,6.355,5.841,17.564,7.736,22.695.592,1.578,1.105,1.776,3.079,1.855v1.381H154.391m-3.158-21.274h-.118c-.829,2.6-2.21,6.986-3.2,10.222h6.552c-.829-2.526-2.447-7.736-3.236-10.222"
                        transform="translate(-116.79 -553.327)"
                        fill="#fff"
                      />
                      <path
                        d="M235.134,557.435c0-1.974-.237-2.132-3.039-2.25v-1.342h19.813v6.71h-1.382c-.987-3.71-1.7-5.092-5.644-5.092h-2.842c-1.066,0-1.3.237-1.3,1.343v8.525h3.75c2.526,0,2.96-.789,3.473-3.395h1.381v8.723h-1.381c-.513-2.644-.947-3.552-3.473-3.552h-3.75v8.052c0,2.408.276,2.841,4.5,2.841,4.46,0,5.447-1.815,6.67-5.881h1.381l-.631,7.5H232.1v-1.38c2.8-.12,3.039-.316,3.039-2.25V557.435"
                        transform="translate(-180.818 -553.685)"
                        fill="#fff"
                      />
                      <path
                        d="M72.141,657.127c-1.984-2.82-3.908-5.624-5.907-8.444h-.015v5.49a13.694,13.694,0,0,0,.09,1.775c.089.612.507.642,1.417.716v.463H64.235v-.463c.746-.059,1.134-.119,1.223-.716a13.751,13.751,0,0,0,.09-1.775v-5.43c0-.791-.015-.82-1.253-.9v-.463h2.774c1.566,2.253,3.565,5.132,5.4,7.7l.015.03v-4.788a13.657,13.657,0,0,0-.09-1.76c-.09-.626-.537-.657-1.447-.716v-.463h3.491v.463c-.731.059-1.1.1-1.193.716a13.6,13.6,0,0,0-.09,1.76v6.8H72.141"
                        transform="translate(-64.235 -618.653)"
                        fill="#fff"
                      />
                      <path
                        d="M100.791,648.745c0-.791-.03-.82-1.253-.9v-.462h7.145v2.327h-.477c-.209-1.446-.522-1.82-2.133-1.82H102.79c-.448,0-.507.06-.507.507v3.371h1.835c1.178,0,1.253-.388,1.372-1.268h.477v3.162h-.477c-.119-.9-.194-1.313-1.372-1.313h-1.835v3.058c0,.955.149,1.193,1.775,1.193,1.76,0,2.387-.358,2.715-2.059h.492l-.3,2.581H99.538v-.463c1.223-.074,1.253-.119,1.253-.9v-7.026"
                        transform="translate(-88.754 -618.654)"
                        fill="#fff"
                      />
                      <path
                        d="M136.434,656.194a12.642,12.642,0,0,1-3.3.6,6,6,0,0,1-3.535-.9,4.855,4.855,0,0,1-1.745-4.027c0-3.328,1.82-5.311,5.325-5.311a7.707,7.707,0,0,1,3.118.6V649.5h-.478a2.521,2.521,0,0,0-2.8-2.4c-2.745,0-3.49,2.356-3.49,4.549,0,1.7.552,4.624,3.744,4.624a3.353,3.353,0,0,0,1.208-.209c.283-.1.463-.269.463-.746v-1.984c0-.686-.075-.761-1.477-.865V652h3.953v.463c-.925.1-.985.164-.985.865v2.864"
                        transform="translate(-108.422 -618.078)"
                        fill="#fff"
                      />
                      <path
                        d="M167.106,646.557c3.163,0,4.7,2.073,4.7,5.131,0,3.043-1.551,5.1-4.714,5.1-3.192,0-4.714-2.058-4.714-5.1,0-3.058,1.522-5.131,4.714-5.131h.015m-.029.537c-2.476,0-3.028,2.536-3.028,4.594s.552,4.579,3.028,4.579,3.043-2.521,3.043-4.579-.566-4.594-3.028-4.594Z"
                        transform="translate(-132.398 -618.078)"
                        fill="#fff"
                      />
                      <path
                        d="M206.333,653.747l-.194,2.417a7.433,7.433,0,0,1-3.1.626c-3.371,0-5.161-1.611-5.161-5.042a5.442,5.442,0,0,1,1.268-3.73,5.169,5.169,0,0,1,3.983-1.461,7.286,7.286,0,0,1,2.983.567v2.267h-.477a2.412,2.412,0,0,0-2.641-2.3c-2.625,0-3.445,2.371-3.445,4.609,0,1.685.552,4.564,3.416,4.564,1.835,0,2.491-1.044,2.879-2.521h.492"
                        transform="translate(-157.051 -618.078)"
                        fill="#fff"
                      />
                      <path
                        d="M231.172,655.77c0,.776.045.806,1.253.9v.463h-3.982v-.463c1.223-.09,1.253-.119,1.253-.9v-7.026c0-.791-.03-.82-1.253-.9v-.462h3.982v.462c-1.208.075-1.253.1-1.253.9v7.026"
                        transform="translate(-178.281 -618.654)"
                        fill="#fff"
                      />
                      <path
                        d="M249.381,646.557c3.163,0,4.7,2.073,4.7,5.131,0,3.043-1.551,5.1-4.714,5.1-3.192,0-4.714-2.058-4.714-5.1,0-3.058,1.521-5.131,4.714-5.131h.015m-.03.537c-2.476,0-3.028,2.536-3.028,4.594s.552,4.579,3.028,4.579,3.043-2.521,3.043-4.579-.567-4.594-3.028-4.594Z"
                        transform="translate(-189.54 -618.078)"
                        fill="#fff"
                      />
                      <path
                        d="M284.822,649.257c-.239-1.432-.91-2.163-2.1-2.163a1.667,1.667,0,0,0-1.79,1.79c0,1.118,1.119,1.64,2.029,2,1.686.642,2.924,1.194,2.924,3.028,0,1.492-.97,2.879-3.49,2.879a4.354,4.354,0,0,1-2.775-.835l-.149-2.283h.477c.358,1.6,1.223,2.6,2.521,2.6a1.775,1.775,0,0,0,2-1.879c0-1.165-1.178-1.776-2.193-2.149-1.447-.537-2.655-1.134-2.655-2.879,0-1.925,1.462-2.8,3.222-2.8a5.225,5.225,0,0,1,2.477.6v2.1h-.492"
                        transform="translate(-213.719 -618.078)"
                        fill="#fff"
                      />
                    </g>
                  </svg>
                  <a
                    href="https://www.baenegocios.com.ar/"
                    className="cover-link"
                    title="BAE Negocios"
                    rel="me nofollow noreferrer"
                    target="_blank"
                  ></a>
                </div>
                <div className="veintitres-menu inner-site-item">
                  <svg
                    width="118.597"
                    height="30.874"
                    viewBox="0 0 118.597 30.874"
                  >
                    <g transform="translate(-927 -272)">
                      <g transform="translate(927 272)">
                        <g transform="translate(0 0)">
                          <path
                            d="M-1645.092,1953.374H-1697V1922.5h51.908Zm-51.006-.921h50.124v-29.012H-1696.1Z"
                            transform="translate(1697 -1922.5)"
                            fill="#fff"
                          />
                        </g>
                        <g transform="translate(50.967 0)">
                          <path
                            d="M-1418.377,1953.374H-1437V1922.5h18.623Zm-17.721-.921h16.839v-29.012H-1436.1Z"
                            transform="translate(1437 -1922.5)"
                            fill="#fff"
                          />
                        </g>
                        <g transform="translate(68.708 0)">
                          <path
                            d="M-1296.807,1953.374H-1346.5V1922.5h49.693Zm-48.811-.921h47.909v-29.012h-47.909Z"
                            transform="translate(1346.5 -1922.5)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                      <g transform="translate(927 274.254)">
                        <rect
                          width="51.947"
                          height="26.464"
                          transform="translate(0 0)"
                          fill="none"
                          opacity="0.93"
                        />
                        <g transform="translate(2.96 3.078)">
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M-1669.629,1968.3l-2.529,16.407h-7.037l-2.705-16.407h4.822l1.51,11.977c.118-.882.333-3.019.608-6.43.157-1.9.333-3.764.51-5.548h4.822Z"
                                  transform="translate(1681.9 -1964.654)"
                                  fill="#fff"
                                />
                                <path
                                  d="M-1604.07,1976.944h-6.979v3.489a3.533,3.533,0,0,0,.177,1.411.678.678,0,0,0,.667.314.83.83,0,0,0,.823-.411,4.178,4.178,0,0,0,.216-1.627v-2.137h5.1v1.2a11.028,11.028,0,0,1-.2,2.294,4.761,4.761,0,0,1-.961,1.705,4.865,4.865,0,0,1-1.921,1.372,7.883,7.883,0,0,1-2.921.451,9.491,9.491,0,0,1-3.019-.451,5.067,5.067,0,0,1-2.039-1.235,4.192,4.192,0,0,1-1-1.725,10.734,10.734,0,0,1-.274-2.744v-4.7a7.47,7.47,0,0,1,.627-3.333,4.1,4.1,0,0,1,2.058-1.862,7.8,7.8,0,0,1,3.274-.647,7.907,7.907,0,0,1,3.744.784,4.626,4.626,0,0,1,2.078,2.078,9.049,9.049,0,0,1,.588,3.646v2.137Zm-5.391-2.627v-1.176a5.418,5.418,0,0,0-.157-1.627.574.574,0,0,0-.588-.353c-.373,0-.608.1-.706.314a6.211,6.211,0,0,0-.137,1.666v1.176Z"
                                  transform="translate(1629.24 -1964.654)"
                                  fill="#fff"
                                />
                                <path
                                  d="M-1541.952,1949.7v2.607h-5.548V1949.7Zm0,3.607v16.447h-5.548v-16.447Z"
                                  transform="translate(1573.846 -1949.7)"
                                  fill="#fff"
                                />
                                <path
                                  d="M-1505.05,1968.594l-.1,1.49a3.861,3.861,0,0,1,1.431-1.333,4.189,4.189,0,0,1,1.96-.451,4.04,4.04,0,0,1,2.274.588,2.68,2.68,0,0,1,1.137,1.51,12.142,12.142,0,0,1,.255,3.019v11.291h-5.371v-11.174a9.569,9.569,0,0,0-.118-2.019c-.078-.235-.294-.353-.666-.353a.685.685,0,0,0-.725.412,9.73,9.73,0,0,0-.137,2.235v10.9h-5.391v-16.114Z"
                                  transform="translate(1544.099 -1964.654)"
                                  fill="#fff"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g transform="translate(976.399 274.646)">
                        <rect
                          width="20.975"
                          height="26.072"
                          transform="translate(0 0)"
                          fill="none"
                          opacity="0.93"
                        />
                        <g transform="translate(3.117 2.999)">
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M-1422.514,1952.32v2.764h1.451v2.764h-1.451v9.37a4.978,4.978,0,0,0,.176,1.921c.118.137.627.2,1.49.2v2.823h-2.176a16.055,16.055,0,0,1-2.627-.157,2.779,2.779,0,0,1-1.392-.706,2.325,2.325,0,0,1-.745-1.255,21.492,21.492,0,0,1-.157-3.313v-8.9h-1.157v-2.764h1.157V1952.3l5.43.02Z"
                                  transform="translate(1429.1 -1952.104)"
                                  fill="#fff"
                                />
                                <path
                                  d="M-1376.453,1951.3v2.607H-1382V1951.3Zm0,3.627v16.447H-1382v-16.447Z"
                                  transform="translate(1391.233 -1951.3)"
                                  fill="#fff"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g transform="translate(996.002 274.646)">
                        <rect
                          width="49.595"
                          height="26.268"
                          transform="translate(0 0)"
                          fill="none"
                          opacity="0.93"
                        />
                        <g transform="translate(3.019 3.117)">
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M-1323.013,1951.9v2.744h1.45v2.764h-1.45v9.311a5.13,5.13,0,0,0,.176,1.921c.118.137.627.2,1.49.2v2.8h-2.176a16.058,16.058,0,0,1-2.627-.157,2.915,2.915,0,0,1-1.392-.686,2.347,2.347,0,0,1-.745-1.235,21.364,21.364,0,0,1-.157-3.313v-8.841h-1.156v-2.764h1.156V1951.9Z"
                                  transform="translate(1329.6 -1951.9)"
                                  fill="#fff"
                                />
                                <path
                                  d="M-1277.029,1968.594l-.216,2.137a4,4,0,0,1,3.411-2.431v5.7a5.036,5.036,0,0,0-2.176.353,1.586,1.586,0,0,0-.843,1.019,15.8,15.8,0,0,0-.157,3.019v6.41h-5.391v-16.231l5.371.02Z"
                                  transform="translate(1291.653 -1965.085)"
                                  fill="#fff"
                                />
                                <path
                                  d="M-1224.27,1974.759h-6.979v3.607a3.706,3.706,0,0,0,.177,1.451.689.689,0,0,0,.666.333.811.811,0,0,0,.823-.431,4.466,4.466,0,0,0,.216-1.686v-2.176h5.1v1.235a11.744,11.744,0,0,1-.2,2.372,4.948,4.948,0,0,1-.961,1.764,4.767,4.767,0,0,1-1.921,1.411,7.854,7.854,0,0,1-2.921.471,8.957,8.957,0,0,1-3.019-.471,5.118,5.118,0,0,1-2.039-1.274,4.393,4.393,0,0,1-1-1.784,11.386,11.386,0,0,1-.275-2.843v-4.881a7.977,7.977,0,0,1,.627-3.45,4.151,4.151,0,0,1,2.058-1.941,7.512,7.512,0,0,1,3.274-.666,7.9,7.9,0,0,1,3.744.8,4.689,4.689,0,0,1,2.078,2.157,9.621,9.621,0,0,1,.588,3.764v2.235Zm-5.41-2.705v-1.215a5.638,5.638,0,0,0-.157-1.666.564.564,0,0,0-.588-.372c-.372,0-.608.1-.706.314a6.687,6.687,0,0,0-.137,1.725v1.215Z"
                                  transform="translate(1254.831 -1963.076)"
                                  fill="#fff"
                                />
                                <path
                                  d="M-1156.73,1971.3h-4.763v-.9a4.565,4.565,0,0,0-.137-1.47c-.1-.216-.333-.314-.706-.314a.885.885,0,0,0-.686.274,1.31,1.31,0,0,0-.216.843,3.75,3.75,0,0,0,.118,1.117,1.624,1.624,0,0,0,.686.784,13.111,13.111,0,0,0,2.333,1.235,8.614,8.614,0,0,1,3.078,2.039,4.487,4.487,0,0,1,.745,2.783,6.692,6.692,0,0,1-.549,3.078,3.68,3.68,0,0,1-1.882,1.608,8.049,8.049,0,0,1-3.156.549,9.1,9.1,0,0,1-3.529-.608,3.905,3.905,0,0,1-2-1.647,6.769,6.769,0,0,1-.549-3.117v-.8h4.783v1.058a5.341,5.341,0,0,0,.176,1.745.691.691,0,0,0,.706.412.977.977,0,0,0,.8-.275,1.869,1.869,0,0,0,.215-1.137,2.471,2.471,0,0,0-.294-1.509,26.1,26.1,0,0,0-3.136-1.784,6.893,6.893,0,0,1-2.9-2.293,5.488,5.488,0,0,1-.51-2.431,6.054,6.054,0,0,1,.549-2.96,3.642,3.642,0,0,1,1.9-1.47,8.521,8.521,0,0,1,3.117-.51,9.551,9.551,0,0,1,3,.412,4.373,4.373,0,0,1,1.882,1.117,2.891,2.891,0,0,1,.8,1.294,8.528,8.528,0,0,1,.137,1.843v1.039Z"
                                  transform="translate(1199.758 -1962.914)"
                                  fill="#fff"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <a
                    href="http://www.veintitres.com.ar/"
                    className="cover-link"
                    title="Revista Veintitrés"
                    rel="me nofollow noreferrer"
                    target="_blank"
                  ></a>
                </div>
                <div className="loa-menu inner-site-item">
                  <svg
                    width="124.125"
                    height="33.614"
                    viewBox="0 0 124.125 33.614"
                  >
                    <g transform="translate(-14242 1777.55)">
                      <g transform="translate(14242 -1777.55)">
                        <path
                          d="M15.338,54.931q0,.516-.027.868a15.755,15.755,0,0,0-.082,1.928l.027,1.927q-3.482-.136-12.592-.136H1.522q-1.2,0-1.2-.231c0-.154.127-.231.381-.231a2.9,2.9,0,0,0,1.741-.38q.245-.217.245-1.3V42.686a2.324,2.324,0,0,0-.165-1.138,1.173,1.173,0,0,0-1.019-.38H.818q-.3,0-.3-.2t.381-.2H8.539c.181,0,.272.073.272.217q0,.244-.707.244-1.007,0-1.183.244a6.378,6.378,0,0,0-.177,2.144v6.461q0,1.982.109,8.876.516.027,1.169.027a23.614,23.614,0,0,0,3.944-.217A3.053,3.053,0,0,0,14.3,57.021a9.854,9.854,0,0,0,.6-2.253q.082-.434.245-.435.19,0,.19.6"
                          transform="translate(-0.325 -33.015)"
                          fill="#fff"
                        />
                        <path
                          d="M91.484,86.561q0,.221-.435.606a4.1,4.1,0,0,1-2.883,1.075,2.33,2.33,0,0,1-1.618-.467,2.765,2.765,0,0,1-.666-1.677,3.718,3.718,0,0,1-3.345,2.226,2.533,2.533,0,0,1-1.89-.733,2.6,2.6,0,0,1-.721-1.9q0-3.42,5.875-4.045v-.57a16.429,16.429,0,0,0-.19-3.339l-.027-.136a1.784,1.784,0,0,0-1.931-1.357,2.009,2.009,0,0,0-1.441.516,1.44,1.44,0,0,0-.544,1q0,.272.653.326.979.081.979,1.194a1.342,1.342,0,0,1-.395.991,1.381,1.381,0,0,1-1.02.394,1.8,1.8,0,0,1-1.292-.475,1.587,1.587,0,0,1-.5-1.208,2.72,2.72,0,0,1,1.169-2.117,4.723,4.723,0,0,1,3.073-.95q2.828,0,3.944,1a3.913,3.913,0,0,1,.9,2.932V84.5q0,1.358.027,1.574.136,1.14.789,1.14a1.878,1.878,0,0,0,1.142-.652.373.373,0,0,1,.218-.136.121.121,0,0,1,.136.138M85.8,83.329V82a2.834,2.834,0,0,0-2.638,2.986q0,1.9,1.306,1.9A1.063,1.063,0,0,0,85.5,86.07a8.806,8.806,0,0,0,.3-2.742"
                          transform="translate(-64.776 -61.494)"
                          fill="#fff"
                        />
                        <path
                          d="M170.232,48.881a9.883,9.883,0,0,1-2.543,6.881,8.254,8.254,0,0,1-12.443-.041,9.865,9.865,0,0,1-2.584-6.868,9.747,9.747,0,0,1,2.57-6.895,8.35,8.35,0,0,1,6.378-2.769,7.9,7.9,0,0,1,6.147,2.782,10.017,10.017,0,0,1,2.475,6.909m-4.787.42q0-5.394-1.278-7.969a2.8,2.8,0,0,0-2.665-1.681q-1.85,0-2.951,2.358a15.111,15.111,0,0,0-1.1,6.315q0,5.747,1.958,8.593a2.689,2.689,0,0,0,2.366,1.192A2.569,2.569,0,0,0,164.3,56.4a18.281,18.281,0,0,0,1.142-7.1"
                          transform="translate(-123.671 -31.742)"
                          fill="#fff"
                        />
                        <path
                          d="M256.811,82.019a6.844,6.844,0,0,1-1.573,4.6,4.957,4.957,0,0,1-3.931,1.842,3.445,3.445,0,0,1-2.874-1.411v6.085a3.408,3.408,0,0,0,.08.96.443.443,0,0,0,.363.257,12.445,12.445,0,0,0,1.437.081q.3,0,.3.26c0,.134-.118.2-.354.2H243.4q-.6,0-.6-.217,0-.19.979-.19.816,0,.911-.163a3.014,3.014,0,0,0,.1-1.032V78.259a.612.612,0,0,0-.435-.706,3.251,3.251,0,0,0-.925-.081h-.517c-.145,0-.218-.054-.218-.163q0-.217.326-.163a12.837,12.837,0,0,0,5.059-1.086.952.952,0,0,1,.136.434l.054.679.027.461a4.34,4.34,0,0,1,1.442-1.241,4.288,4.288,0,0,1,1.822-.334,4.8,4.8,0,0,1,3.753,1.693,6.207,6.207,0,0,1,1.5,4.266m-4-.108q0-5.172-2.325-5.172a2.076,2.076,0,0,0-1.73.975,2.77,2.77,0,0,0-.324,1.544v5.334a4.46,4.46,0,0,0,.433,2.356,1.926,1.926,0,0,0,1.676.921q2.27,0,2.271-5.957"
                          transform="translate(-196.569 -61.609)"
                          fill="#fff"
                        />
                        <path
                          d="M323.71,57.967c0,.127-.082.19-.244.19H316.61c-.217,0-.325-.058-.325-.174q0-.13.626-.152.924-.027,1.088-.2a2.023,2.023,0,0,0,.163-1.078V48.718a2.463,2.463,0,0,0-.177-1.241q-.177-.205-1.074-.2a4.167,4.167,0,0,1-.667-.027c-.064-.018-.1-.081-.1-.19q0-.189.408-.19a13.434,13.434,0,0,0,5.113-.923q.054.325.136,1.792v8.551q0,1.113.2,1.3a2.8,2.8,0,0,0,1.4.19c.2,0,.3.064.3.19m-1.9-17.21a1.8,1.8,0,0,1-.529,1.3A1.72,1.72,0,0,1,320,42.6a1.8,1.8,0,0,1-1.307-.516,1.741,1.741,0,0,1-.529-1.3,1.625,1.625,0,0,1,.529-1.249,1.929,1.929,0,0,1,1.363-.489,1.721,1.721,0,0,1,1.252.489,1.637,1.637,0,0,1,.5,1.222"
                          transform="translate(-256.044 -31.626)"
                          fill="#fff"
                        />
                        <path
                          d="M365.793,87.371q0,.218-.68.217h-5.82c-.254,0-.381-.068-.381-.2q0-.177.321-.177h.214q.694,0,.814-.177a3.244,3.244,0,0,0,.12-1.214V80.551a8.939,8.939,0,0,0-.375-3.492,1.271,1.271,0,0,0-1.151-.491,1.891,1.891,0,0,0-1.365.514,1.727,1.727,0,0,0-.536,1.3v8.205a.543.543,0,0,0,.231.42,2.633,2.633,0,0,0,.884.122c.145,0,.218.054.218.162s-.064.172-.19.19-.581.027-1.36.027-1.424.009-1.931.027q-1.5.054-3.046.055-.326,0-.327-.19,0-.217.83-.217t.965-.325l.082-.379V80.251q0-2.626-.054-2.735-.082-.406-.734-.406H351.6q-.435,0-.435-.177c0-.118.108-.186.325-.2a9.875,9.875,0,0,0,4.845-1.276.85.85,0,0,1,.3-.109q.217,0,.217.434v1.547a4.468,4.468,0,0,1,3.7-1.873q2.339,0,3.046,1.629a4.679,4.679,0,0,1,.367,1.52q.067.842.068,3.475v3.936a1.969,1.969,0,0,0,.136.991q.135.15.884.149t.748.217"
                          transform="translate(-284.392 -61.03)"
                          fill="#fff"
                        />
                        <path
                          d="M431.462,57.967c0,.127-.081.19-.244.19h-6.856c-.217,0-.325-.058-.325-.174q0-.13.626-.152.925-.027,1.088-.2a2.023,2.023,0,0,0,.163-1.078V48.718a2.46,2.46,0,0,0-.177-1.241q-.177-.205-1.074-.2a4.17,4.17,0,0,1-.666-.027c-.064-.018-.1-.081-.1-.19q0-.189.408-.19a13.435,13.435,0,0,0,5.113-.923q.054.325.136,1.792v8.551q0,1.113.2,1.3a2.8,2.8,0,0,0,1.4.19c.2,0,.3.064.3.19m-1.9-17.21a1.8,1.8,0,0,1-.529,1.3,1.719,1.719,0,0,1-1.279.543,1.8,1.8,0,0,1-1.308-.516,1.742,1.742,0,0,1-.529-1.3,1.625,1.625,0,0,1,.529-1.249,1.93,1.93,0,0,1,1.363-.489,1.721,1.721,0,0,1,1.251.489,1.637,1.637,0,0,1,.5,1.222"
                          transform="translate(-343.289 -31.626)"
                          fill="#fff"
                        />
                        <path
                          d="M590.287,87.371q0,.218-.68.217h-5.82q-.382,0-.381-.2,0-.177.32-.177h.214q.694,0,.815-.177a3.245,3.245,0,0,0,.12-1.214V80.551a8.948,8.948,0,0,0-.375-3.492,1.271,1.271,0,0,0-1.151-.491,1.892,1.892,0,0,0-1.366.514,1.726,1.726,0,0,0-.535,1.3v8.205a.541.541,0,0,0,.231.42,2.633,2.633,0,0,0,.884.122q.218,0,.217.162t-.19.19q-.191.027-1.36.027t-1.931.027q-1.5.054-3.046.055-.327,0-.327-.19,0-.217.83-.217t.966-.325l.081-.379V80.251q0-2.626-.054-2.735-.081-.406-.734-.406h-.925q-.435,0-.435-.177c0-.118.108-.186.324-.2a9.875,9.875,0,0,0,4.846-1.276.85.85,0,0,1,.3-.109q.217,0,.217.434v1.547a4.469,4.469,0,0,1,3.7-1.873q2.339,0,3.046,1.629a4.678,4.678,0,0,1,.367,1.52q.067.842.068,3.475v3.936a1.969,1.969,0,0,0,.136.991q.135.15.884.149t.748.217"
                          transform="translate(-466.162 -61.03)"
                          fill="#fff"
                        />
                        <path
                          d="M473.547,7.4q.234,0,1.122-.84l5.141-4.571L481.632.352l.421-.373h-5.936q-.7,1.914-1.215,3.219l-.047.139q-1.5,3.733-1.5,3.872a.165.165,0,0,0,.187.187m8.67,5.761a10.035,10.035,0,0,0-7.455-3.2,10.626,10.626,0,0,0-7.735,3.149,10.3,10.3,0,0,0-3.2,7.627,10.089,10.089,0,0,0,3.2,7.44,10.462,10.462,0,0,0,7.595,3.149A10.716,10.716,0,0,0,481.4,28.9a9.766,9.766,0,0,0,3.926-8.07,10.616,10.616,0,0,0-3.108-7.674m-6.79,15.127c-.914,1.761-2.894,2.49-3.693,2a3.752,3.752,0,0,0,1.142-2.2c-2.758-.871-4.541-3.856-4.541-7.516,0-4.261,2.536-7.588,6.24-7.588s6.24,3.327,6.24,7.588c0,4.023-2.153,7.23-5.389,7.71"
                          transform="translate(-375.615 0.021)"
                          fill="#fff"
                        />
                        <path
                          d="M306.217,155.436h.771l1.412,4.018h-.748l-.346-1.03h-1.412l-.34,1.03h-.748Zm.907,2.394-.357-1.075c-.068-.226-.159-.623-.159-.623H306.6s-.091.4-.159.623l-.363,1.075Z"
                          transform="translate(-246.859 -125.908)"
                          fill="#fff"
                        />
                        <path
                          d="M330.064,155.436h.731V158a.891.891,0,0,0,1.78,0v-2.569h.732v2.575a1.626,1.626,0,0,1-3.243,0Z"
                          transform="translate(-267.31 -125.908)"
                          fill="#fff"
                        />
                        <path
                          d="M355.034,158.135a1.606,1.606,0,0,0,1,.424c.363,0,.59-.187.59-.458,0-.764-1.877-.605-1.877-1.856a1.227,1.227,0,0,1,1.372-1.166,1.773,1.773,0,0,1,1.179.43l-.323.594a1.414,1.414,0,0,0-.884-.351c-.369,0-.612.181-.612.458,0,.747,1.877.555,1.877,1.833a1.2,1.2,0,0,1-1.338,1.188,1.967,1.967,0,0,1-1.378-.549Z"
                          transform="translate(-287.207 -125.618)"
                          fill="#fff"
                        />
                        <path
                          d="M376.093,156.064h-1.321v-.628h3.368v.628h-1.321v3.39h-.726Z"
                          transform="translate(-303.51 -125.908)"
                          fill="#fff"
                        />
                        <path
                          d="M399.613,155.436h1.326a1.812,1.812,0,0,1,.76.108,1.114,1.114,0,0,1,.68,1.1,1.156,1.156,0,0,1-.675,1.1v.012a1.47,1.47,0,0,1,.131.209l.828,1.494h-.822l-.794-1.5h-.7v1.5h-.731ZM401,157.32a.59.59,0,0,0,.635-.639.54.54,0,0,0-.317-.549,1.039,1.039,0,0,0-.442-.068h-.533v1.256Z"
                          transform="translate(-323.623 -125.908)"
                          fill="#fff"
                        />
                        <path
                          d="M421.933,155.436h.771l1.412,4.018h-.749l-.346-1.03H421.61l-.34,1.03h-.748Zm.907,2.394-.357-1.075c-.068-.226-.159-.623-.159-.623h-.011s-.091.4-.159.623l-.363,1.075Z"
                          transform="translate(-340.553 -125.908)"
                          fill="#fff"
                        />
                        <path
                          d="M446.374,155.436h.731v3.389h1.741v.628h-2.472Z"
                          transform="translate(-361.485 -125.908)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </svg>
                  <a
                    href="https://www.laopinionaustral.com.ar/"
                    className="cover-link"
                    title="La Opinión Austral"
                    rel="me nofollow noreferrer"
                    target="_blank"
                  ></a>
                </div>
                <div className="cm-musica-menu inner-site-item">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 232 125"
                    style={{ enableBackground: "new 0 0 232 125" }}
                    xmlSpace="preserve"
                  >
                    <g>
                      <path
                        d="M112.4,67.8c0,31.1-25.2,56.3-56.3,56.3C25.2,124.1,0,98.9,0,67.8s25.2-56.3,56.3-56.3
                                                C87.2,11.6,112.4,36.8,112.4,67.8"
                        fill="#EB008B"
                      />
                      <path
                        d="M48.9,76.5v7.9c0,9.6-4.7,16-13.7,18c-9.1,1.9-13.8-2.5-13.8-12.1l-0.1-31c0-9.6,4.7-16,13.7-17.9
                                                c9.1-1.9,13.8,2.5,13.8,12.1v5.8l-8.7,1.9v-6.4c0-4.3-1.9-5.5-4.8-4.9c-2.9,0.6-4.8,2.7-4.8,6.9L30.6,89c0,4.3,1.9,5.4,4.8,4.8
                                                s4.8-2.5,4.8-6.8v-8.5L48.9,76.5z"
                        fill="#FFFFFF"
                      />
                      <polygon
                        points="70.6,76.5 76.8,32.9 89.7,30.1 89.8,89.7 81.1,91.6 81,48.9 74.7,93 66,94.8 59,54.2 59.1,96.3
                                                51.2,98 51,38.4 63.7,35.7"
                        fill="#FFFFFF"
                      />
                      <polygon
                        points="126.1,29 129.7,28.2 129.7,30.6 126.1,31.3 126.1,36.2 130.6,35.2 130.6,37.6 123.5,39.1 123.5,22.6
                                                130.6,21.1 130.6,23.4 126.1,24.4"
                        fill="#FFFFFF"
                      />
                      <polygon
                        points="132.2,20.7 134.8,20.2 134.8,34.3 139,33.4 139,35.7 132.2,37.2"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M151.3,27v2.2c0,2.6-1.3,4.4-3.9,5c-2.5,0.6-3.9-0.7-3.9-3.3v-8.6c0-2.6,1.3-4.4,3.9-5
                                                c2.5-0.5,3.9,0.7,3.9,3.3v1.6l-2.4,0.5v-1.8c0-1.2-0.5-1.5-1.3-1.3c-0.8,0.2-1.3,0.7-1.3,1.9v8.9c0,1.2,0.5,1.5,1.3,1.3
                                                c0.8-0.2,1.3-0.7,1.3-1.9v-2.4L151.3,27z"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M155.4,27l2.5-0.5l-1.2-8.1L155.4,27z M161.3,31l-2.6,0.6l-0.4-2.9l-3.2,0.7l-0.4,3.1l-2.4,0.5l2.6-17l3.8-0.8
                                                L161.3,31z"
                        fill="#FFFFFF"
                      />
                      <polygon
                        points="164.8,18.3 164.8,30.2 162.5,30.7 162.5,14.2 165.7,13.5 168.4,22.8 168.4,13 170.7,12.5 170.7,29
                                                168,29.5"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M174.9,22.8l2.5-0.5l-1.2-8.1L174.9,22.8z M180.9,26.8l-2.6,0.6l-0.5-2.9l-3.2,0.7l-0.4,3.1l-2.4,0.5l2.6-17.1
                                                l3.8-0.8L180.9,26.8z"
                        fill="#FFFFFF"
                      />
                      <polygon
                        points="182.1,10 184.6,9.5 184.6,23.6 188.9,22.7 188.9,25 182.1,26.5"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M196.3,9.3v11.8l1.5-0.3c0.8-0.2,1.3-0.7,1.3-1.9v-8.6c0-1.2-0.5-1.5-1.3-1.3L196.3,9.3z M193.7,7.5l4.1-0.9
                                                c2.6-0.5,3.9,0.6,3.9,3.3v8.3c0,2.6-1.3,4.3-3.9,4.9l-4.1,0.9V7.5z"
                        fill="#FFFFFF"
                      />
                      <polygon
                        points="205.9,11.9 209.5,11.1 209.5,13.5 205.9,14.2 205.9,19.1 210.4,18.1 210.4,20.5 203.3,22 203.3,5.5
                                                210.4,4 210.4,6.3 205.9,7.3"
                        fill="#FFFFFF"
                      />
                      <polygon
                        points="215.6,2.8 218.2,2.3 218.2,16.4 222.5,15.5 222.5,17.9 215.6,19.3"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M226.1,11.9l2.5-0.5l-1.2-8.1L226.1,11.9z M232,15.8l-2.6,0.6l-0.4-2.9l-3.2,0.7l-0.4,3.1l-2.4,0.5l2.6-17
                                                l3.8-0.8L232,15.8z"
                        fill="#FFFFFF"
                      />
                      <polygon
                        points="134.8,70 138.5,45.3 145.9,43.7 145.9,77.5 140.8,78.5 140.8,54.4 137.2,79.3 132.1,80.4 128.2,57.4
                                                128.2,81.3 123.5,82.3 123.5,48.5 130.9,46.9"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M163.2,32.9l-4.9,6.4l-3.6,0.8L158,34L163.2,32.9z M154.8,41.8v26.1c0,2.4,1.1,3,2.8,2.7
                                                c1.7-0.3,2.8-1.5,2.8-3.9V40.6l5-1.1v25.8c0,5.4-2.7,9.1-7.9,10.2c-5.2,1.1-7.9-1.4-7.9-6.8V43L154.8,41.8z"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M176,36.9c5.2-1.1,7.8,1.4,7.8,6.8v1.1l-5,1.1v-1.4c0-2.4-1-3.1-2.7-2.8c-1.7,0.4-2.7,1.5-2.7,3.9
                                                c0,7,10.4,6,10.4,15.7c0,5.4-2.7,9.1-7.9,10.2c-5.2,1.1-7.9-1.4-7.9-6.8v-2.1l5-1.1v2.4c0,2.4,1.1,3.1,2.8,2.7s2.7-1.5,2.7-3.9
                                                c0-7-10.4-6-10.4-15.7C168.3,41.6,170.9,38,176,36.9"
                        fill="#FFFFFF"
                      />
                      <polygon
                        points="186.9,34.9 192.3,33.8 192.3,67.5 186.9,68.7"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M211.6,50.9v4.5c0,5.4-2.7,9.1-7.9,10.2c-5.2,1.1-7.9-1.4-7.9-6.8V41.2c0-5.4,2.7-9.1,7.9-10.2
                                                c5.2-1.1,7.9,1.4,7.9,6.8v3.3l-5,1.1v-3.6c0-2.4-1.1-3.1-2.8-2.7c-1.7,0.4-2.8,1.5-2.8,3.9V58c0,2.4,1.1,3.1,2.8,2.7
                                                c1.7-0.4,2.8-1.5,2.8-3.9v-5L211.6,50.9z"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M219.9,51l5.1-1.1l-2.6-16.6L219.9,51z M232,59l-5.4,1.1l-0.9-5.9l-6.5,1.4l-0.9,6.3l-4.9,1.1l5.4-35l7.8-1.7
                                                L232,59z"
                        fill="#FFFFFF"
                      />
                    </g>
                  </svg>
                  <a
                    href="/seccion/elcanaldelamusica/"
                    className="cover-link"
                    title="CM El canal de la música"
                  ></a>
                </div>
                <div className="radio-fmq-menu inner-site-item">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 240 145"
                    style={{ enableBackground: "new 0 0 240 145" }}
                    xmlSpace="preserve"
                  >
                    <g>
                      <g>
                        <rect
                          x="5.4"
                          y="5.1"
                          width="151"
                          height="133.4"
                          fill="#FFFFFF"
                        />
                      </g>
                      <g>
                        <polygon
                          points="156.4,144.2 0.2,144.2 0,0.1 156.1,0.1 156.1,7.5 7.4,7.5 7.6,136.8 156.4,136.8"
                          fill="#231F20"
                        />
                      </g>
                      <g>
                        <g>
                          <g>
                            <path
                              d="M20.4,17.7h42l3.7,20.1H42.6v25.6h17.9V82H42.6v43.6H20.4V17.7z"
                              fill="#231F20"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M93.8,74.7v50.9h-21v-108h22.8l11.8,45.6l11.8-45.6H142v108h-21V74.7l-13.7,43.2L93.8,74.7z"
                              fill="#231F20"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <rect
                              x="156"
                              width="84"
                              height="144.1"
                              fill="#EC1C24"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <g>
                              <path
                                d="M211.7,12.3c10.7,0,15.4,5.8,15.4,14.7v81.4c0,12.5-4.7,17.6-17.7,17.6h-3v9.1h-18.2V126h-2.8
                                                        c-13,0-17.7-5-17.7-17.6V27.1c0-8.9,4.7-14.7,15.4-14.7H211.7z M192.8,32.2c-1.6,0-2.2,0.9-2.2,2.4v69.1c0,1.7,0.3,2.4,2.2,2.4
                                                        h9.1c1.9,0,2.2-0.6,2.2-2.4V34.4c0-1.4-0.5-2.2-2-2.2H192.8z"
                                fill="#FFFFFF"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <a
                    href="/seccion/fmq/"
                    className="cover-link"
                    title="Radio FMQ"
                  ></a>
                </div>
                <div className="cronishop-menu inner-site-item">
                  <svg
                    width="34.903"
                    height="38.928"
                    viewBox="0 0 34.903 38.928"
                  >
                    <path
                      d="M12.615,0h2.053a1.269,1.269,0,0,0,.269.146,6.208,6.208,0,0,1,4.991,6.47c0,.512,0,1.024,0,1.585,1.358,0,2.566,0,3.774,0,1.162,0,1.473.246,1.584,1.369.252,2.562.488,5.126.686,7.692a1.1,1.1,0,0,1-.416.8c-1.4,1.063-2.824,2.106-4.269,3.112a16.953,16.953,0,0,1-9.333,3.42,3.114,3.114,0,0,1-3.182-4.006c.712-3.218,4.858-6.381,8.221-6.273a2.211,2.211,0,0,1,2.212,1.337c.2.711-.285,1.54-1.26,2.166-.45.289-.789.478-1.045-.268a1.293,1.293,0,0,0-.918-.733,7.139,7.139,0,0,0-2.451.225,2.08,2.08,0,0,0-1.371,2.017c.081.813.7,1.383,1.784,1.634,2.5.582,6.343-1.185,7.513-3.451a3.105,3.105,0,0,0-1.847-4.623,10.776,10.776,0,0,0-3.488-.389A14.7,14.7,0,0,0,4.54,18.954c-2.335,3.328-2.3,7.67,3.084,9.251.075.022.152.041.229.056a14.444,14.444,0,0,0,9.233-1.022,29.9,29.9,0,0,0,7.5-5.308c.528-.487,1.045-.986,1.614-1.524a2.079,2.079,0,0,1,.1.32c.327,3.584.644,7.169.982,10.752a1.483,1.483,0,0,1-.775,1.507H.773c-.862-.465-.811-1.239-.733-2.053.263-2.742.5-5.487.749-8.231.385-4.286.758-8.573,1.158-12.858C2.084,8.376,2.319,8.2,3.841,8.2H7.356c0-.772-.007-1.423,0-2.075A6.184,6.184,0,0,1,11.22.489C11.676.305,12.15.162,12.615,0ZM9.786,8.149h7.77c0-.7.019-1.35,0-2a3.723,3.723,0,0,0-2.071-3.3,3.69,3.69,0,0,0-3.891.119C9.6,4.188,9.594,6.108,9.786,8.149Z"
                      transform="matrix(0.966, -0.259, 0.259, 0.966, 0, 7.065)"
                      fill="#fff"
                    />
                  </svg>
                  <p>Cronishop</p>
                  <a
                    href="https://cronishop.cronica.com.ar/"
                    className="cover-link"
                    title="Cronishop, la tienda de Crónica"
                    rel="me nofollow noreferrer"
                    target="_blank"
                  ></a>
                </div>
              </div>
              <div className="seguinos">
                <p className="kicker">¡Seguinos!</p>
                <div className="seguinos-redes flex-container justify-center">
                  <a
                    href="https://www.facebook.com/cronicadiario/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Seguinos en Facebook"
                    aria-label="Seguinos en Facebook"
                  >
                    <svg className="fb-icon" viewBox="0 0 8.65 16">
                      <use xlinkHref="#fb-svg"></use>
                    </svg>
                  </a>
                  <a
                    href="https://twitter.com/cronica/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Seguinos en Twitter"
                    aria-label="Seguinos en Twitter"
                  >
                    <svg className="tw-icon" viewBox="0 0 19.692 16">
                      <use xlinkHref="#tw-svg"></use>
                    </svg>
                  </a>
                  <a
                    href="https://www.instagram.com/cronicaweb/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Seguinos en Instagram"
                    aria-label="Seguinos en Instagram"
                  >
                    <svg className="ig-icon" viewBox="0 0 18 18">
                      <use xlinkHref="#ig-svg"></use>
                    </svg>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCT7KFGv6s2a-rh2Jq8ZdM1g"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Suscribite a nuestro canal de YouTube"
                    aria-label="Suscribite a nuestro canal de YouTube"
                  >
                    <svg className="yt-icon" viewBox="0 0 20.277 14.001">
                      <use xlinkHref="#yt-svg"></use>
                    </svg>
                  </a>
                  <a
                    href="https://www.tiktok.com/@cronica?lang=es"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Seguinos en Toktok"
                    aria-label="Seguinos en Toktok"
                  >
                    <svg
                      className="tiktok-icon"
                      width={22}
                      height={22}
                      viewBox="0 0 19.692 16"
                    >
                      <use xlinkHref="#tiktok-svg"></use>
                    </svg>
                  </a>
                  <a
                    href="https://news.google.com/publications/CAAqBwgKMK7Z_wow-tn5Ag?oc=3&ceid=AR:es-419"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Seguinos en Google News"
                    aria-label="Seguinos en Google News"
                  >
                    <svg className="google-icon" viewBox="0 0 17.645 18">
                      <use xlinkHref="#google-svg"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
export default Menu;
